
// // import React, { useState } from 'react';
// // import { 
// //     FaEye, FaEdit, FaTrash, FaCheck, FaTimes, 
// //     FaFilePdf, FaPrint, FaSearch, FaFilter,
// //     FaCheckCircle, FaClock, FaExclamationCircle,
// //     FaDollarSign, FaUser, FaCalendarAlt, FaMapMarkerAlt,
// //     FaBuilding, FaPhone, FaEnvelope, FaPaperPlane,
// //     FaPlus
// // } from 'react-icons/fa';

// // const SalesQuotation = () => {
// //     const [searchTerm, setSearchTerm] = useState('');
// //     const [filterStatus, setFilterStatus] = useState('all');
// //     const [showViewModal, setShowViewModal] = useState(false);
// //     const [showSendModal, setShowSendModal] = useState(false);
// //     const [selectedQuotation, setSelectedQuotation] = useState(null);
// //     const [selectedVendors, setSelectedVendors] = useState({});
// //     const [selectAll, setSelectAll] = useState(false);

// //     // Sample quotation data (these come from enquiries that were sent)
// //     const [quotations, setQuotations] = useState([
// //         {
// //             id: 1,
// //             enquiryId: 1,
// //             customerName: 'John Doe',
// //             companyName: 'ABC Corp',
// //             email: 'john@example.com',
// //             phone: '9876543210',
// //             eventType: 'Wedding',
// //             eventDate: '2026-08-15',
// //             city: 'Hyderabad',
// //             status: 'pending', // pending, approved, rejected, quoted
// //             totalPlates: 180,
// //             estimatedBudget: 45000,
// //             vendors: ['Vendor A', 'Vendor C'],
// //             createdAt: '2026-07-28',
// //             quotationDate: '2026-07-29',
// //             quotedAmount: null,
// //             items: [
// //                 { name: 'Veg Biryani', quantity: 100, price: 120 },
// //                 { name: 'Chicken Biryani', quantity: 50, price: 180 },
// //                 { name: 'Gulab Jamun', quantity: 30, price: 60 },
// //             ]
// //         },
// //         {
// //             id: 2,
// //             enquiryId: 2,
// //             customerName: 'Jane Smith',
// //             companyName: 'XYZ Ltd',
// //             email: 'jane@example.com',
// //             phone: '8765432109',
// //             eventType: 'Corporate',
// //             eventDate: '2026-09-20',
// //             city: 'Mumbai',
// //             status: 'pending',
// //             totalPlates: 350,
// //             estimatedBudget: 85000,
// //             vendors: ['Vendor B', 'Vendor D'],
// //             createdAt: '2026-07-27',
// //             quotationDate: '2026-07-28',
// //             quotedAmount: null,
// //             items: [
// //                 { name: 'Paneer Butter Masala', quantity: 200, price: 140 },
// //                 { name: 'Butter Chicken', quantity: 100, price: 220 },
// //                 { name: 'Naan', quantity: 50, price: 30 },
// //             ]
// //         },
// //         {
// //             id: 3,
// //             enquiryId: 3,
// //             customerName: 'Robert Wilson',
// //             companyName: 'Wilson & Co',
// //             email: 'robert@example.com',
// //             phone: '7654321098',
// //             eventType: 'Birthday',
// //             eventDate: '2026-08-05',
// //             city: 'Delhi',
// //             status: 'rejected',
// //             totalPlates: 80,
// //             estimatedBudget: 20000,
// //             vendors: ['Vendor A'],
// //             createdAt: '2026-07-26',
// //             quotationDate: '2026-07-27',
// //             quotedAmount: 22000,
// //             items: [
// //                 { name: 'Pizza', quantity: 80, price: 180 },
// //                 { name: 'Pasta', quantity: 80, price: 120 },
// //             ]
// //         }
// //     ]);

// //     // Vendor list for send modal
// //     const vendors = [
// //         { id: 1, name: 'Vendor A', email: 'vendorA@example.com', city: 'Hyderabad' },
// //         { id: 2, name: 'Vendor B', email: 'vendorB@example.com', city: 'Mumbai' },
// //         { id: 3, name: 'Vendor C', email: 'vendorC@example.com', city: 'Delhi' },
// //         { id: 4, name: 'Vendor D', email: 'vendorD@example.com', city: 'Bangalore' },
// //         { id: 5, name: 'Vendor E', email: 'vendorE@example.com', city: 'Chennai' },
// //     ];

// //     // Get status badge
// //     const getStatusBadge = (status) => {
// //         switch(status) {
// //             case 'pending':
// //                 return <span style={pendingBadgeStyle}><FaClock size={12} /> Pending</span>;
// //             case 'approved':
// //                 return <span style={approvedBadgeStyle}><FaCheckCircle size={12} /> Approved</span>;
// //             case 'rejected':
// //                 return <span style={rejectedBadgeStyle}><FaTimes size={12} /> Rejected</span>;
// //             case 'quoted':
// //                 return <span style={quotedBadgeStyle}><FaDollarSign size={12} /> Quoted</span>;
// //             default:
// //                 return <span style={pendingBadgeStyle}>Unknown</span>;
// //         }
// //     };

// //     // Filter quotations
// //     const filteredQuotations = quotations.filter(q => {
// //         const matchesSearch = 
// //             q.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //             q.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //             q.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //             q.eventType.toLowerCase().includes(searchTerm.toLowerCase());
        
// //         const matchesStatus = filterStatus === 'all' || q.status === filterStatus;
        
// //         return matchesSearch && matchesStatus;
// //     });

// //     // Get status count
// //     const getStatusCount = (status) => {
// //         return quotations.filter(q => q.status === status).length;
// //     };

// //     // Handle view quotation
// //     const handleViewQuotation = (quotation) => {
// //         setSelectedQuotation(quotation);
// //         setShowViewModal(true);
// //     };

// //     // Handle send to vendors
// //     const handleSendToVendors = () => {
// //         const selected = Object.keys(selectedVendors).filter(key => selectedVendors[key]);
// //         if (selected.length === 0) {
// //             alert('Please select at least one vendor');
// //             return;
// //         }
        
// //         // Update quotation status
// //         setQuotations(prev => prev.map(q => 
// //             q.id === selectedQuotation?.id ? { ...q, status: 'quoted' } : q
// //         ));
        
// //         setShowSendModal(false);
// //         setSelectedVendors({});
// //         setSelectAll(false);
// //         alert(`Quotation sent to ${selected.length} vendor(s)`);
// //     };

// //     // Handle open send modal
// //     const handleOpenSendModal = (quotation) => {
// //         setSelectedQuotation(quotation);
// //         setSelectedVendors({});
// //         setSelectAll(false);
// //         setShowSendModal(true);
// //     };

// //     // Handle select all vendors
// //     const handleSelectAll = () => {
// //         const newState = {};
// //         vendors.forEach(v => newState[v.id] = !selectAll);
// //         setSelectedVendors(newState);
// //         setSelectAll(!selectAll);
// //     };

// //     // Handle individual vendor selection
// //     const handleVendorSelect = (vendorId) => {
// //         setSelectedVendors(prev => ({
// //             ...prev,
// //             [vendorId]: !prev[vendorId]
// //         }));
// //     };

// //     // Handle approve quotation
// //     const handleApprove = (id) => {
// //         setQuotations(prev => prev.map(q => 
// //             q.id === id ? { ...q, status: 'approved' } : q
// //         ));
// //     };

// //     // Handle reject quotation
// //     const handleReject = (id) => {
// //         setQuotations(prev => prev.map(q => 
// //             q.id === id ? { ...q, status: 'rejected' } : q
// //         ));
// //     };

// //     // Handle print quotation
// //     const handlePrint = (quotation) => {
// //         alert(`Printing quotation #${quotation.id} for ${quotation.customerName}`);
// //     };

// //     // Handle export PDF
// //     const handleExportPDF = (quotation) => {
// //         alert(`Exporting quotation #${quotation.id} as PDF`);
// //     };

// //     return (
// //         <div style={containerStyle}>
// //             {/* Header */}
// //             <div style={headerStyle}>
// //                 <div style={headerLeftStyle}>
// //                     <h2 style={titleStyle}>Sales Quotations</h2>
// //                     <span style={countStyle}>{quotations.length} quotations</span>
// //                 </div>
// //                 <div style={headerRightStyle}>
// //                     <button style={exportAllButtonStyle}>
// //                         <FaFilePdf size={14} />
// //                         Export All
// //                     </button>
// //                 </div>
// //             </div>

// //             {/* Stats Cards */}
// //             <div style={statsContainerStyle}>
// //                 <div style={statCardStyle}>
// //                     <div style={statIconStyle} className="stat-pending">📋</div>
// //                     <div>
// //                         <div style={statNumberStyle}>{getStatusCount('pending')}</div>
// //                         <div style={statLabelStyle}>Pending</div>
// //                     </div>
// //                 </div>
// //                 <div style={statCardStyle}>
// //                     <div style={statIconStyle} className="stat-quoted">💰</div>
// //                     <div>
// //                         <div style={statNumberStyle}>{getStatusCount('quoted')}</div>
// //                         <div style={statLabelStyle}>Quoted</div>
// //                     </div>
// //                 </div>
// //                 <div style={statCardStyle}>
// //                     <div style={statIconStyle} className="stat-approved">✅</div>
// //                     <div>
// //                         <div style={statNumberStyle}>{getStatusCount('approved')}</div>
// //                         <div style={statLabelStyle}>Approved</div>
// //                     </div>
// //                 </div>
// //                 <div style={statCardStyle}>
// //                     <div style={statIconStyle} className="stat-rejected">❌</div>
// //                     <div>
// //                         <div style={statNumberStyle}>{getStatusCount('rejected')}</div>
// //                         <div style={statLabelStyle}>Rejected</div>
// //                     </div>
// //                 </div>
// //             </div>

// //             {/* Search and Filter */}
// //             <div style={searchFilterContainerStyle}>
// //                 <div style={searchContainerStyle}>
// //                     <FaSearch style={searchIconStyle} />
// //                     <input
// //                         type="text"
// //                         placeholder="Search quotations..."
// //                         value={searchTerm}
// //                         onChange={(e) => setSearchTerm(e.target.value)}
// //                         style={searchInputStyle}
// //                     />
// //                 </div>
// //                 <div style={filterContainerStyle}>
// //                     <FaFilter style={filterIconStyle} />
// //                     <select
// //                         value={filterStatus}
// //                         onChange={(e) => setFilterStatus(e.target.value)}
// //                         style={filterSelectStyle}
// //                     >
// //                         <option value="all">All Status</option>
// //                         <option value="pending">Pending</option>
// //                         <option value="quoted">Quoted</option>
// //                         <option value="approved">Approved</option>
// //                         <option value="rejected">Rejected</option>
// //                     </select>
// //                 </div>
// //             </div>

// //             {/* Table */}
// //             <div style={tableCardStyle}>
// //                 <div style={tableWrapperStyle}>
// //                     <table style={tableStyle}>
// //                         <thead>
// //                             <tr>
// //                                 <th style={{ width: '5%', textAlign: 'center' }}>#</th>
// //                                 <th style={{ width: '14%', textAlign: 'center' }}>Customer</th>
// //                                 <th style={{ width: '10%', textAlign: 'center' }}>Event</th>
// //                                 <th style={{ width: '10%', textAlign: 'center' }}>Date</th>
// //                                 <th style={{ width: '8%', textAlign: 'center' }}>Plates</th>
// //                                 <th style={{ width: '10%', textAlign: 'center' }}>Budget</th>
// //                                 <th style={{ width: '10%', textAlign: 'center' }}>Quoted</th>
// //                                 <th style={{ width: '8%', textAlign: 'center' }}>Status</th>
// //                                 <th style={{ width: '10%', textAlign: 'center' }}>Vendors</th>
// //                                 <th style={{ width: '15%', textAlign: 'center' }}>Actions</th>
// //                             </tr>
// //                         </thead>
// //                         <tbody>
// //                             {filteredQuotations.length === 0 ? (
// //                                 <tr>
// //                                     <td colSpan="10" style={emptyStateStyle}>
// //                                         No quotations found
// //                                     </td>
// //                                 </tr>
// //                             ) : (
// //                                 filteredQuotations.map((quotation, index) => (
// //                                     <tr key={quotation.id} style={tableRowStyle}>
// //                                         <td style={{ ...tableCellStyle, textAlign: 'center' }}>{index + 1}</td>
// //                                         <td style={{ ...tableCellStyle, textAlign: 'center' }}>
// //                                             <div>
// //                                                 <div style={{ fontWeight: 600 }}>{quotation.customerName}</div>
// //                                                 <div style={{ fontSize: '11px', color: '#888' }}>{quotation.companyName}</div>
// //                                             </div>
// //                                         </td>
// //                                         <td style={{ ...tableCellStyle, textAlign: 'center' }}>{quotation.eventType}</td>
// //                                         <td style={{ ...tableCellStyle, textAlign: 'center' }}>{quotation.eventDate}</td>
// //                                         <td style={{ ...tableCellStyle, textAlign: 'center' }}>
// //                                             <span style={platesBadgeStyle}>{quotation.totalPlates}</span>
// //                                         </td>
// //                                         <td style={{ ...tableCellStyle, textAlign: 'center', fontWeight: 600, color: '#e66d33' }}>
// //                                             ₹{quotation.estimatedBudget.toLocaleString()}
// //                                         </td>
// //                                         <td style={{ ...tableCellStyle, textAlign: 'center' }}>
// //                                             {quotation.quotedAmount ? (
// //                                                 <span style={quotedAmountStyle}>
// //                                                     ₹{quotation.quotedAmount.toLocaleString()}
// //                                                 </span>
// //                                             ) : (
// //                                                 <span style={{ color: '#bbb' }}>—</span>
// //                                             )}
// //                                         </td>
// //                                         <td style={{ ...tableCellStyle, textAlign: 'center' }}>{getStatusBadge(quotation.status)}</td>
// //                                         <td style={{ ...tableCellStyle, textAlign: 'center' }}>
// //                                             <div style={vendorsContainerStyle}>
// //                                                 {quotation.vendors.map((v, i) => (
// //                                                     <span key={i} style={vendorTagStyle}>{v}</span>
// //                                                 ))}
// //                                             </div>
// //                                         </td>
// //                                         <td style={{ ...tableCellStyle, textAlign: 'center' }}>
// //                                             <div style={actionGroupStyle}>
// //                                                 <button
// //                                                     onClick={() => handleViewQuotation(quotation)}
// //                                                     style={viewButtonStyle}
// //                                                     title="View"
// //                                                 >
// //                                                     <FaEye size={14} />
// //                                                 </button>
// //                                                 {quotation.status === 'pending' && (
// //                                                     <>
// //                                                         <button
// //                                                             onClick={() => handleOpenSendModal(quotation)}
// //                                                             style={sendButtonStyle}
// //                                                             title="Send to Vendors"
// //                                                         >
// //                                                             <FaPaperPlane size={14} />
// //                                                         </button>
// //                                                         <button
// //                                                             onClick={() => handleApprove(quotation.id)}
// //                                                             style={approveButtonStyle}
// //                                                             title="Approve"
// //                                                         >
// //                                                             <FaCheck size={14} />
// //                                                         </button>
// //                                                         <button
// //                                                             onClick={() => handleReject(quotation.id)}
// //                                                             style={rejectButtonStyle}
// //                                                             title="Reject"
// //                                                         >
// //                                                             <FaTimes size={14} />
// //                                                         </button>
// //                                                     </>
// //                                                 )}
// //                                                 <button
// //                                                     onClick={() => handlePrint(quotation)}
// //                                                     style={printButtonStyle}
// //                                                     title="Print"
// //                                                 >
// //                                                     <FaPrint size={14} />
// //                                                 </button>
// //                                                 <button
// //                                                     onClick={() => handleExportPDF(quotation)}
// //                                                     style={pdfButtonStyle}
// //                                                     title="Export PDF"
// //                                                 >
// //                                                     <FaFilePdf size={14} />
// //                                                 </button>
// //                                             </div>
// //                                         </td>
// //                                     </tr>
// //                                 ))
// //                             )}
// //                         </tbody>
// //                     </table>
// //                 </div>
// //             </div>

// //             {/* View Quotation Modal */}
// //             {showViewModal && selectedQuotation && (
// //                 <div style={modalOverlayStyle} onClick={() => setShowViewModal(false)}>
// //                     <div style={{ ...modalStyle, maxWidth: '800px' }} onClick={(e) => e.stopPropagation()}>
// //                         <div style={modalHeaderStyle}>
// //                             <h3 style={modalTitleStyle}>
// //                                 Quotation #{selectedQuotation.id}
// //                             </h3>
// //                             <button
// //                                 onClick={() => setShowViewModal(false)}
// //                                 style={modalCloseStyle}
// //                             >
// //                                 <FaTimes />
// //                             </button>
// //                         </div>

// //                         <div style={modalBodyStyle}>
// //                             {/* Customer Info */}
// //                             <div style={quotationHeaderStyle}>
// //                                 <div style={quotationHeaderLeftStyle}>
// //                                     <div style={quotationCustomerStyle}>
// //                                         <h4>{selectedQuotation.customerName}</h4>
// //                                         <p>{selectedQuotation.companyName}</p>
// //                                         <div style={contactInfoStyle}>
// //                                             <span><FaEnvelope size={12} /> {selectedQuotation.email}</span>
// //                                             <span><FaPhone size={12} /> {selectedQuotation.phone}</span>
// //                                         </div>
// //                                     </div>
// //                                 </div>
// //                                 <div style={quotationHeaderRightStyle}>
// //                                     <div style={quotationMetaStyle}>
// //                                         <div><strong>Status:</strong> {getStatusBadge(selectedQuotation.status)}</div>
// //                                         <div><strong>Created:</strong> {selectedQuotation.createdAt}</div>
// //                                         <div><strong>Quoted:</strong> {selectedQuotation.quotationDate || '—'}</div>
// //                                     </div>
// //                                 </div>
// //                             </div>

// //                             {/* Event Details */}
// //                             <div style={quotationEventStyle}>
// //                                 <div style={quotationEventItemStyle}>
// //                                     <FaCalendarAlt size={14} />
// //                                     <span><strong>Event:</strong> {selectedQuotation.eventType}</span>
// //                                 </div>
// //                                 <div style={quotationEventItemStyle}>
// //                                     <FaCalendarAlt size={14} />
// //                                     <span><strong>Date:</strong> {selectedQuotation.eventDate}</span>
// //                                 </div>
// //                                 <div style={quotationEventItemStyle}>
// //                                     <FaMapMarkerAlt size={14} />
// //                                     <span><strong>Location:</strong> {selectedQuotation.city}</span>
// //                                 </div>
// //                             </div>

// //                             {/* Items Table */}
// //                             <div style={quotationItemsStyle}>
// //                                 <h4 style={itemsTitleStyle}>Menu Items</h4>
// //                                 <table style={itemsTableStyle}>
// //                                     <thead>
// //                                         <tr>
// //                                             <th style={{ textAlign: 'left' }}>Item</th>
// //                                             <th style={{ textAlign: 'center' }}>Quantity</th>
// //                                             <th style={{ textAlign: 'center' }}>Price (₹)</th>
// //                                             <th style={{ textAlign: 'right' }}>Total (₹)</th>
// //                                         </tr>
// //                                     </thead>
// //                                     <tbody>
// //                                         {selectedQuotation.items.map((item, idx) => (
// //                                             <tr key={idx}>
// //                                                 <td>{item.name}</td>
// //                                                 <td style={{ textAlign: 'center' }}>{item.quantity}</td>
// //                                                 <td style={{ textAlign: 'center' }}>₹{item.price}</td>
// //                                                 <td style={{ textAlign: 'right' }}>₹{(item.quantity * item.price).toLocaleString()}</td>
// //                                             </tr>
// //                                         ))}
// //                                     </tbody>
// //                                     <tfoot>
// //                                         <tr>
// //                                             <td colSpan="3" style={{ textAlign: 'right', fontWeight: 600 }}>Total:</td>
// //                                             <td style={{ textAlign: 'right', fontWeight: 700, color: '#e66d33' }}>
// //                                                 ₹{(selectedQuotation.items.reduce((sum, item) => sum + (item.quantity * item.price), 0)).toLocaleString()}
// //                                             </td>
// //                                         </tr>
// //                                     </tfoot>
// //                                 </table>
// //                             </div>

// //                             {/* Vendors */}
// //                             <div style={quotationVendorsStyle}>
// //                                 <strong>Vendors:</strong>
// //                                 {selectedQuotation.vendors.map((v, i) => (
// //                                     <span key={i} style={vendorTagLargeStyle}>{v}</span>
// //                                 ))}
// //                             </div>

// //                             {/* Summary */}
// //                             <div style={quotationSummaryStyle}>
// //                                 <div style={summaryRowStyle}>
// //                                     <span>Estimated Budget:</span>
// //                                     <span style={summaryValueStyle}>₹{selectedQuotation.estimatedBudget.toLocaleString()}</span>
// //                                 </div>
// //                                 {selectedQuotation.quotedAmount && (
// //                                     <div style={summaryRowStyle}>
// //                                         <span>Quoted Amount:</span>
// //                                         <span style={quotedSummaryValueStyle}>₹{selectedQuotation.quotedAmount.toLocaleString()}</span>
// //                                     </div>
// //                                 )}
// //                                 <div style={summaryRowStyle}>
// //                                     <span>Total Plates:</span>
// //                                     <span>{selectedQuotation.totalPlates}</span>
// //                                 </div>
// //                             </div>

// //                             {/* Action Buttons */}
// //                             <div style={formActionStyle}>
// //                                 <button
// //                                     onClick={() => setShowViewModal(false)}
// //                                     style={cancelButtonStyle}
// //                                 >
// //                                     Close
// //                                 </button>
// //                                 <button
// //                                     onClick={() => handlePrint(selectedQuotation)}
// //                                     style={printLargeButtonStyle}
// //                                 >
// //                                     <FaPrint size={14} />
// //                                     Print
// //                                 </button>
// //                                 <button
// //                                     onClick={() => handleExportPDF(selectedQuotation)}
// //                                     style={pdfLargeButtonStyle}
// //                                 >
// //                                     <FaFilePdf size={14} />
// //                                     Export PDF
// //                                 </button>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}

// //             {/* Send to Vendors Modal */}
// //             {showSendModal && selectedQuotation && (
// //                 <div style={modalOverlayStyle} onClick={() => setShowSendModal(false)}>
// //                     <div style={{ ...modalStyle, maxWidth: '550px' }} onClick={(e) => e.stopPropagation()}>
// //                         <div style={modalHeaderStyle}>
// //                             <h3 style={modalTitleStyle}>Send Quotation to Vendors</h3>
// //                             <button
// //                                 onClick={() => setShowSendModal(false)}
// //                                 style={modalCloseStyle}
// //                             >
// //                                 <FaTimes />
// //                             </button>
// //                         </div>

// //                         <div style={modalBodyStyle}>
// //                             <div style={sendInfoStyle}>
// //                                 <p><strong>Customer:</strong> {selectedQuotation.customerName}</p>
// //                                 <p><strong>Event:</strong> {selectedQuotation.eventType} - {selectedQuotation.eventDate}</p>
// //                                 <p><strong>Budget:</strong> ₹{selectedQuotation.estimatedBudget.toLocaleString()}</p>
// //                             </div>

// //                             <div style={vendorSelectAllStyle}>
// //                                 <label style={checkboxLabelStyle}>
// //                                     <input
// //                                         type="checkbox"
// //                                         checked={selectAll}
// //                                         onChange={handleSelectAll}
// //                                     />
// //                                     <strong>Select All Vendors</strong>
// //                                 </label>
// //                             </div>

// //                             <div style={vendorListStyle}>
// //                                 {vendors.map(vendor => (
// //                                     <div key={vendor.id} style={vendorItemStyle}>
// //                                         <label style={checkboxLabelStyle}>
// //                                             <input
// //                                                 type="checkbox"
// //                                                 checked={selectedVendors[vendor.id] || false}
// //                                                 onChange={() => handleVendorSelect(vendor.id)}
// //                                             />
// //                                             <div>
// //                                                 <div style={{ fontWeight: 600 }}>{vendor.name}</div>
// //                                                 <div style={{ fontSize: '12px', color: '#888' }}>{vendor.email}</div>
// //                                             </div>
// //                                         </label>
// //                                     </div>
// //                                 ))}
// //                             </div>

// //                             <div style={formActionStyle}>
// //                                 <button
// //                                     type="button"
// //                                     onClick={() => setShowSendModal(false)}
// //                                     style={cancelButtonStyle}
// //                                 >
// //                                     Cancel
// //                                 </button>
// //                                 <button
// //                                     onClick={handleSendToVendors}
// //                                     style={sendButtonLargeStyle}
// //                                 >
// //                                     <FaPaperPlane size={14} />
// //                                     Send to Selected Vendors
// //                                 </button>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}

// //             <style>{`
// //                 .stat-pending { background: #fff3cd; }
// //                 .stat-quoted { background: #cce5ff; }
// //                 .stat-approved { background: #d4edda; }
// //                 .stat-rejected { background: #f8d7da; }
// //             `}</style>
// //         </div>
// //     );
// // };

// // // ─── Styles ──────────────────────────────────────────────────────

// // const containerStyle = {
// //     padding: '20px',
// // };

// // const headerStyle = {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     alignItems: 'center',
// //     marginBottom: '20px',
// //     flexWrap: 'wrap',
// //     gap: '12px',
// // };

// // const headerLeftStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '12px',
// // };

// // const headerRightStyle = {
// //     display: 'flex',
// //     gap: '10px',
// // };

// // const titleStyle = {
// //     fontSize: '24px',
// //     fontWeight: 700,
// //     color: '#333',
// //     margin: 0,
// // };

// // const countStyle = {
// //     fontSize: '14px',
// //     color: '#888',
// //     background: '#f0f0f0',
// //     padding: '4px 12px',
// //     borderRadius: '20px',
// // };

// // const exportAllButtonStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     padding: '10px 20px',
// //     background: '#dc3545',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '10px',
// //     fontWeight: 600,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // // ─── Stats Styles ──────────────────────────────────────────────

// // const statsContainerStyle = {
// //     display: 'grid',
// //     gridTemplateColumns: 'repeat(4, 1fr)',
// //     gap: '16px',
// //     marginBottom: '20px',
// // };

// // const statCardStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '12px',
// //     background: '#fff',
// //     padding: '16px 20px',
// //     borderRadius: '12px',
// //     boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
// //     border: '1px solid #f0ebe6',
// // };

// // const statIconStyle = {
// //     fontSize: '28px',
// //     width: '48px',
// //     height: '48px',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     borderRadius: '12px',
// // };

// // const statNumberStyle = {
// //     fontSize: '22px',
// //     fontWeight: 700,
// //     color: '#333',
// // };

// // const statLabelStyle = {
// //     fontSize: '13px',
// //     color: '#888',
// // };

// // // ─── Search & Filter Styles ─────────────────────────────────────

// // const searchFilterContainerStyle = {
// //     display: 'flex',
// //     gap: '12px',
// //     marginBottom: '20px',
// //     flexWrap: 'wrap',
// // };

// // const searchContainerStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     flex: 1,
// //     background: '#fff',
// //     border: '1px solid #e0d6ce',
// //     borderRadius: '10px',
// //     padding: '0 14px',
// // };

// // const searchIconStyle = {
// //     color: '#999',
// //     marginRight: '10px',
// // };

// // const searchInputStyle = {
// //     flex: 1,
// //     padding: '12px 0',
// //     border: 'none',
// //     outline: 'none',
// //     fontSize: '14px',
// //     background: 'transparent',
// // };

// // const filterContainerStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     background: '#fff',
// //     border: '1px solid #e0d6ce',
// //     borderRadius: '10px',
// //     padding: '0 14px',
// // };

// // const filterIconStyle = {
// //     color: '#999',
// //     marginRight: '10px',
// // };

// // const filterSelectStyle = {
// //     padding: '12px 8px',
// //     border: 'none',
// //     outline: 'none',
// //     fontSize: '14px',
// //     background: 'transparent',
// //     cursor: 'pointer',
// // };

// // // ─── Table Styles ──────────────────────────────────────────────

// // const tableCardStyle = {
// //     background: '#fff',
// //     borderRadius: '12px',
// //     boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
// //     overflow: 'hidden',
// //     border: '1px solid #f0ebe6',
// // };

// // const tableWrapperStyle = {
// //     overflowX: 'auto',
// // };

// // const tableStyle = {
// //     width: '100%',
// //     borderCollapse: 'collapse',
// //     minWidth: '1100px',
// // };

// // const tableRowStyle = {
// //     borderBottom: '1px solid #f0ebe6',
// //     transition: 'background 0.2s ease',
// // };

// // const tableCellStyle = {
// //     padding: '12px 14px',
// //     fontSize: '13px',
// //     color: '#333',
// // };

// // const emptyStateStyle = {
// //     padding: '40px',
// //     textAlign: 'center',
// //     color: '#999',
// // };

// // // ─── Badge Styles ──────────────────────────────────────────────

// // const platesBadgeStyle = {
// //     display: 'inline-block',
// //     padding: '2px 10px',
// //     background: 'rgba(230, 126, 34, 0.1)',
// //     borderRadius: '12px',
// //     fontSize: '12px',
// //     fontWeight: 600,
// //     color: '#e66d33',
// // };

// // const pendingBadgeStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '4px',
// //     padding: '2px 10px',
// //     background: '#fff3cd',
// //     borderRadius: '12px',
// //     fontSize: '11px',
// //     fontWeight: 600,
// //     color: '#856404',
// // };

// // const approvedBadgeStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '4px',
// //     padding: '2px 10px',
// //     background: '#d4edda',
// //     borderRadius: '12px',
// //     fontSize: '11px',
// //     fontWeight: 600,
// //     color: '#155724',
// // };

// // const rejectedBadgeStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '4px',
// //     padding: '2px 10px',
// //     background: '#f8d7da',
// //     borderRadius: '12px',
// //     fontSize: '11px',
// //     fontWeight: 600,
// //     color: '#721c24',
// // };

// // const quotedBadgeStyle = {
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     gap: '4px',
// //     padding: '2px 10px',
// //     background: '#cce5ff',
// //     borderRadius: '12px',
// //     fontSize: '11px',
// //     fontWeight: 600,
// //     color: '#004085',
// // };

// // const quotedAmountStyle = {
// //     fontWeight: 600,
// //     color: '#28a745',
// // };

// // // ─── Vendor Tags ──────────────────────────────────────────────

// // const vendorsContainerStyle = {
// //     display: 'flex',
// //     flexWrap: 'wrap',
// //     gap: '4px',
// //     justifyContent: 'center',
// // };

// // const vendorTagStyle = {
// //     padding: '2px 8px',
// //     background: '#f0f0f0',
// //     borderRadius: '4px',
// //     fontSize: '10px',
// //     color: '#666',
// // };

// // const vendorTagLargeStyle = {
// //     display: 'inline-block',
// //     padding: '4px 12px',
// //     background: '#f0f0f0',
// //     borderRadius: '6px',
// //     fontSize: '13px',
// //     color: '#555',
// //     marginRight: '6px',
// // };

// // // ─── Action Buttons ─────────────────────────────────────────────

// // const actionGroupStyle = {
// //     display: 'flex',
// //     gap: '6px',
// //     flexWrap: 'wrap',
// //     justifyContent: 'center',
// // };

// // const viewButtonStyle = {
// //     padding: '6px 10px',
// //     background: 'rgba(23, 162, 184, 0.1)',
// //     color: '#17a2b8',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const sendButtonStyle = {
// //     padding: '6px 10px',
// //     background: 'rgba(40, 167, 69, 0.1)',
// //     color: '#28a745',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const approveButtonStyle = {
// //     padding: '6px 10px',
// //     background: 'rgba(40, 167, 69, 0.1)',
// //     color: '#28a745',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const rejectButtonStyle = {
// //     padding: '6px 10px',
// //     background: 'rgba(220, 53, 69, 0.1)',
// //     color: '#dc3545',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const printButtonStyle = {
// //     padding: '6px 10px',
// //     background: 'rgba(108, 117, 125, 0.1)',
// //     color: '#6c757d',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const pdfButtonStyle = {
// //     padding: '6px 10px',
// //     background: 'rgba(220, 53, 69, 0.1)',
// //     color: '#dc3545',
// //     border: 'none',
// //     borderRadius: '6px',
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // // ─── Modal Styles ──────────────────────────────────────────────

// // const modalOverlayStyle = {
// //     position: 'fixed',
// //     top: 0,
// //     left: 0,
// //     right: 0,
// //     bottom: 0,
// //     background: 'rgba(0,0,0,0.5)',
// //     backdropFilter: 'blur(4px)',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     zIndex: 9999,
// //     padding: '20px',
// // };

// // const modalStyle = {
// //     background: '#fff',
// //     borderRadius: '16px',
// //     width: '100%',
// //     maxWidth: '700px',
// //     maxHeight: '90vh',
// //     overflow: 'auto',
// //     boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
// // };

// // const modalHeaderStyle = {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     alignItems: 'center',
// //     padding: '20px 24px',
// //     borderBottom: '1px solid #f0ebe6',
// //     position: 'sticky',
// //     top: 0,
// //     background: '#fff',
// //     zIndex: 1,
// // };

// // const modalTitleStyle = {
// //     margin: 0,
// //     fontSize: '18px',
// //     fontWeight: 700,
// //     color: '#333',
// // };

// // const modalCloseStyle = {
// //     background: 'none',
// //     border: 'none',
// //     fontSize: '20px',
// //     cursor: 'pointer',
// //     color: '#999',
// //     padding: '4px 8px',
// // };

// // const modalBodyStyle = {
// //     padding: '24px',
// // };

// // // ─── Quotation View Styles ─────────────────────────────────────

// // const quotationHeaderStyle = {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     padding: '16px',
// //     background: '#f8f9fa',
// //     borderRadius: '10px',
// //     marginBottom: '16px',
// //     flexWrap: 'wrap',
// //     gap: '12px',
// // };

// // const quotationHeaderLeftStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '16px',
// // };

// // const quotationCustomerStyle = {
// //     '& h4': {
// //         margin: 0,
// //         fontSize: '16px',
// //         fontWeight: 700,
// //         color: '#333',
// //     },
// //     '& p': {
// //         margin: '2px 0',
// //         fontSize: '14px',
// //         color: '#666',
// //     },
// // };

// // const contactInfoStyle = {
// //     display: 'flex',
// //     gap: '16px',
// //     marginTop: '4px',
// //     '& span': {
// //         display: 'flex',
// //         alignItems: 'center',
// //         gap: '4px',
// //         fontSize: '13px',
// //         color: '#666',
// //     },
// // };

// // const quotationHeaderRightStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// // };

// // const quotationMetaStyle = {
// //     fontSize: '13px',
// //     color: '#666',
// //     '& div': {
// //         marginBottom: '2px',
// //     },
// // };

// // const quotationEventStyle = {
// //     display: 'flex',
// //     gap: '20px',
// //     padding: '12px 16px',
// //     background: '#fff',
// //     borderRadius: '8px',
// //     border: '1px solid #f0ebe6',
// //     marginBottom: '16px',
// //     flexWrap: 'wrap',
// // };

// // const quotationEventItemStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '6px',
// //     fontSize: '14px',
// //     color: '#555',
// // };

// // const quotationItemsStyle = {
// //     marginBottom: '16px',
// // };

// // const itemsTitleStyle = {
// //     margin: '0 0 8px 0',
// //     fontSize: '15px',
// //     fontWeight: 600,
// //     color: '#333',
// // };

// // const itemsTableStyle = {
// //     width: '100%',
// //     borderCollapse: 'collapse',
// //     fontSize: '13px',
// //     '& th, & td': {
// //         padding: '8px 12px',
// //         borderBottom: '1px solid #f0ebe6',
// //     },
// //     '& tfoot td': {
// //         borderTop: '2px solid #333',
// //         paddingTop: '10px',
// //     },
// // };

// // const quotationVendorsStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     padding: '12px 16px',
// //     background: '#f8f9fa',
// //     borderRadius: '8px',
// //     marginBottom: '16px',
// //     flexWrap: 'wrap',
// // };

// // const quotationSummaryStyle = {
// //     padding: '16px',
// //     background: '#fff',
// //     borderRadius: '8px',
// //     border: '1px solid #f0ebe6',
// //     marginBottom: '16px',
// // };

// // const summaryRowStyle = {
// //     display: 'flex',
// //     justifyContent: 'space-between',
// //     padding: '4px 0',
// //     fontSize: '14px',
// // };

// // const summaryValueStyle = {
// //     fontWeight: 600,
// //     color: '#333',
// // };

// // const quotedSummaryValueStyle = {
// //     fontWeight: 700,
// //     color: '#28a745',
// // };

// // // ─── Form Action Styles ────────────────────────────────────────

// // const formActionStyle = {
// //     display: 'flex',
// //     gap: '12px',
// //     justifyContent: 'flex-end',
// //     marginTop: '16px',
// //     paddingTop: '16px',
// //     borderTop: '1px solid #f0ebe6',
// // };

// // const cancelButtonStyle = {
// //     padding: '10px 24px',
// //     background: '#f0f0f0',
// //     color: '#666',
// //     border: 'none',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     fontWeight: 500,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const printLargeButtonStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     padding: '10px 24px',
// //     background: '#6c757d',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     fontWeight: 600,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // const pdfLargeButtonStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     padding: '10px 24px',
// //     background: '#dc3545',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     fontWeight: 600,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // // ─── Send Modal Styles ──────────────────────────────────────────

// // const sendInfoStyle = {
// //     background: '#f8f9fa',
// //     padding: '12px 16px',
// //     borderRadius: '8px',
// //     marginBottom: '16px',
// //     '& p': {
// //         margin: '4px 0',
// //         fontSize: '14px',
// //     },
// // };

// // const vendorSelectAllStyle = {
// //     padding: '12px 0',
// //     borderBottom: '1px solid #f0ebe6',
// //     marginBottom: '12px',
// // };

// // const vendorListStyle = {
// //     maxHeight: '250px',
// //     overflowY: 'auto',
// //     marginBottom: '16px',
// // };

// // const vendorItemStyle = {
// //     padding: '10px 12px',
// //     borderBottom: '1px solid #f5f5f5',
// // };

// // const checkboxLabelStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '12px',
// //     cursor: 'pointer',
// //     fontSize: '14px',
// // };

// // const sendButtonLargeStyle = {
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //     padding: '10px 24px',
// //     background: '#28a745',
// //     color: '#fff',
// //     border: 'none',
// //     borderRadius: '8px',
// //     fontSize: '14px',
// //     fontWeight: 600,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// // };

// // export default SalesQuotation;






// // SalesQuotation.jsx
// import React, { useState, useEffect } from 'react';
// import { 
//     FaEye, FaEdit, FaTrash, FaCheck, FaTimes, 
//     FaFilePdf, FaPrint, FaSearch, FaFilter,
//     FaCheckCircle, FaClock, FaExclamationCircle,
//     FaDollarSign, FaUser, FaCalendarAlt, FaMapMarkerAlt,
//     FaBuilding, FaPhone, FaEnvelope, FaPaperPlane,
//     FaPlus, FaSpinner, FaSync
// } from 'react-icons/fa';
// import { getAllEnquiries } from '../../Servicefile/salesService';

// const SalesQuotation = () => {
//     const [searchTerm, setSearchTerm] = useState('');
//     const [filterStatus, setFilterStatus] = useState('all');
//     const [showViewModal, setShowViewModal] = useState(false);
//     const [showSendModal, setShowSendModal] = useState(false);
//     const [selectedQuotation, setSelectedQuotation] = useState(null);
//     const [selectedVendors, setSelectedVendors] = useState({});
//     const [selectAll, setSelectAll] = useState(false);
//     const [leads, setLeads] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [quotations, setQuotations] = useState([]);
//     const [filteredQuotations, setFilteredQuotations] = useState([]);

//     // Vendor list for send modal
//     const vendors = [
//         { id: 1, name: 'Vendor A', email: 'vendorA@example.com', city: 'Hyderabad' },
//         { id: 2, name: 'Vendor B', email: 'vendorB@example.com', city: 'Mumbai' },
//         { id: 3, name: 'Vendor C', email: 'vendorC@example.com', city: 'Delhi' },
//         { id: 4, name: 'Vendor D', email: 'vendorD@example.com', city: 'Bangalore' },
//         { id: 5, name: 'Vendor E', email: 'vendorE@example.com', city: 'Chennai' },
//     ];

//     // Static quotation data for each lead (since we don't have a quotations API)
//     const generateQuotationForLead = (lead) => {
//         // Generate random items based on lead data
//         const items = [];
//         const dishNames = ['Veg Biryani', 'Chicken Biryani', 'Paneer Butter Masala', 'Butter Chicken', 'Gulab Jamun', 'Naan', 'Pizza', 'Pasta', 'Tandoori Chicken', 'Dal Makhani'];
        
//         // Generate 2-4 random items
//         const numItems = Math.floor(Math.random() * 3) + 2;
//         for (let i = 0; i < numItems; i++) {
//             const randomIndex = Math.floor(Math.random() * dishNames.length);
//             const quantity = Math.floor(Math.random() * 50) + 10;
//             const price = Math.floor(Math.random() * 100) + 50;
//             items.push({
//                 name: dishNames[randomIndex],
//                 quantity: quantity,
//                 price: price
//             });
//         }

//         // Random vendors (2-3 vendors)
//         const vendorNames = ['Vendor A', 'Vendor B', 'Vendor C', 'Vendor D', 'Vendor E'];
//         const numVendors = Math.floor(Math.random() * 2) + 1;
//         const selectedVendors = [];
//         const shuffled = [...vendorNames].sort(() => 0.5 - Math.random());
//         for (let i = 0; i < numVendors; i++) {
//             selectedVendors.push(shuffled[i]);
//         }

//         const statuses = ['pending', 'quoted', 'approved', 'rejected'];
//         const status = statuses[Math.floor(Math.random() * statuses.length)];

//         return {
//             id: lead.id || lead.enquiryId,
//             enquiryId: lead.id || lead.enquiryId,
//             customerName: lead.fullName || 'Unknown Customer',
//             companyName: lead.companyName || 'N/A',
//             email: lead.email || 'N/A',
//             phone: lead.phoneNumber || 'N/A',
//             eventType: lead.eventType || 'Event',
//             eventDate: lead.eventDate || lead.fromDate || 'N/A',
//             city: lead.city || 'N/A',
//             status: status,
//             totalPlates: (lead.vegPlates || 0) + (lead.nonVegPlates || 0) + (lead.mixedPlates || 0),
//             estimatedBudget: lead.budget || 0,
//             vendors: selectedVendors,
//             createdAt: lead.createdAt ? new Date(lead.createdAt).toLocaleDateString() : 'N/A',
//             quotationDate: new Date().toLocaleDateString(),
//             quotedAmount: status === 'quoted' || status === 'approved' ? Math.round((lead.budget || 0) * (0.8 + Math.random() * 0.3)) : null,
//             items: items,
//             leadData: lead
//         };
//     };

//     // Fetch approved leads
//     const fetchApprovedLeads = async () => {
//         setLoading(true);
//         try {
//             const data = await getAllEnquiries();
//             // Filter only approved leads
//             const approvedLeads = data.filter(lead => lead.leadStatus === 'APPROVED');
//             console.log('✅ Approved leads:', approvedLeads);
            
//             setLeads(approvedLeads);
            
//             // Generate quotations for each approved lead
//             const generatedQuotations = approvedLeads.map(lead => generateQuotationForLead(lead));
//             setQuotations(generatedQuotations);
//             setFilteredQuotations(generatedQuotations);
            
//         } catch (error) {
//             console.error('❌ Error fetching approved leads:', error);
//             alert('Failed to fetch approved leads');
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Fetch on mount
//     useEffect(() => {
//         fetchApprovedLeads();
//     }, []);

//     // Filter quotations
//     useEffect(() => {
//         let filtered = quotations;
        
//         // Search filter
//         if (searchTerm) {
//             filtered = filtered.filter(q => 
//                 q.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                 q.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                 q.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                 q.eventType.toLowerCase().includes(searchTerm.toLowerCase())
//             );
//         }
        
//         // Status filter
//         if (filterStatus !== 'all') {
//             filtered = filtered.filter(q => q.status === filterStatus);
//         }
        
//         setFilteredQuotations(filtered);
//     }, [searchTerm, filterStatus, quotations]);

//     // Get status badge
//     const getStatusBadge = (status) => {
//         switch(status) {
//             case 'pending':
//                 return <span style={pendingBadgeStyle}><FaClock size={12} /> Pending</span>;
//             case 'approved':
//                 return <span style={approvedBadgeStyle}><FaCheckCircle size={12} /> Approved</span>;
//             case 'rejected':
//                 return <span style={rejectedBadgeStyle}><FaTimes size={12} /> Rejected</span>;
//             case 'quoted':
//                 return <span style={quotedBadgeStyle}><FaDollarSign size={12} /> Quoted</span>;
//             default:
//                 return <span style={pendingBadgeStyle}>Unknown</span>;
//         }
//     };

//     // Get status count
//     const getStatusCount = (status) => {
//         return quotations.filter(q => q.status === status).length;
//     };

//     // Handle view quotation
//     const handleViewQuotation = (quotation) => {
//         setSelectedQuotation(quotation);
//         setShowViewModal(true);
//     };

//     // Handle send to vendors
//     const handleSendToVendors = () => {
//         const selected = Object.keys(selectedVendors).filter(key => selectedVendors[key]);
//         if (selected.length === 0) {
//             alert('Please select at least one vendor');
//             return;
//         }
        
//         // Update quotation status
//         setQuotations(prev => prev.map(q => 
//             q.id === selectedQuotation?.id ? { ...q, status: 'quoted' } : q
//         ));
        
//         setShowSendModal(false);
//         setSelectedVendors({});
//         setSelectAll(false);
//         alert(`Quotation sent to ${selected.length} vendor(s)`);
//     };

//     // Handle open send modal
//     const handleOpenSendModal = (quotation) => {
//         setSelectedQuotation(quotation);
//         setSelectedVendors({});
//         setSelectAll(false);
//         setShowSendModal(true);
//     };

//     // Handle select all vendors
//     const handleSelectAll = () => {
//         const newState = {};
//         vendors.forEach(v => newState[v.id] = !selectAll);
//         setSelectedVendors(newState);
//         setSelectAll(!selectAll);
//     };

//     // Handle individual vendor selection
//     const handleVendorSelect = (vendorId) => {
//         setSelectedVendors(prev => ({
//             ...prev,
//             [vendorId]: !prev[vendorId]
//         }));
//     };

//     // Handle approve quotation
//     const handleApprove = (id) => {
//         setQuotations(prev => prev.map(q => 
//             q.id === id ? { ...q, status: 'approved' } : q
//         ));
//     };

//     // Handle reject quotation
//     const handleReject = (id) => {
//         setQuotations(prev => prev.map(q => 
//             q.id === id ? { ...q, status: 'rejected' } : q
//         ));
//     };

//     // Handle print quotation
//     const handlePrint = (quotation) => {
//         alert(`Printing quotation #${quotation.id} for ${quotation.customerName}`);
//     };

//     // Handle export PDF
//     const handleExportPDF = (quotation) => {
//         alert(`Exporting quotation #${quotation.id} as PDF`);
//     };

//     // Handle refresh
//     const handleRefresh = () => {
//         fetchApprovedLeads();
//     };

//     return (
//         <div style={containerStyle}>
//             {/* Header */}
//             <div style={headerStyle}>
//                 <div style={headerLeftStyle}>
//                     <div style={headerIconStyle}>
//                         <FaDollarSign size={22} />
//                     </div>
//                     <div>
//                         <h2 style={titleStyle}>Quotations</h2>
//                         <p style={subtitleStyle}>Manage quotations for approved leads</p>
//                     </div>
//                 </div>
//                 <div style={headerRightStyle}>
//                     <button onClick={handleRefresh} style={refreshButtonStyle}>
//                         <FaSync size={14} />
//                         Refresh
//                     </button>
//                     <button style={exportAllButtonStyle}>
//                         <FaFilePdf size={14} />
//                         Export All
//                     </button>
//                 </div>
//             </div>

//             {/* Stats Cards */}
//             <div style={statsContainerStyle}>
//                 <div style={statCardStyle}>
//                     <div style={{...statIconWrapperStyle, background: '#FEF3C7'}}>
//                         <FaClock style={{color: '#D97706'}} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{getStatusCount('pending')}</div>
//                         <div style={statLabelStyle}>Pending</div>
//                     </div>
//                 </div>
//                 <div style={statCardStyle}>
//                     <div style={{...statIconWrapperStyle, background: '#E0E7FF'}}>
//                         <FaDollarSign style={{color: '#4F46E5'}} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{getStatusCount('quoted')}</div>
//                         <div style={statLabelStyle}>Quoted</div>
//                     </div>
//                 </div>
//                 <div style={statCardStyle}>
//                     <div style={{...statIconWrapperStyle, background: '#D1FAE5'}}>
//                         <FaCheckCircle style={{color: '#059669'}} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{getStatusCount('approved')}</div>
//                         <div style={statLabelStyle}>Approved</div>
//                     </div>
//                 </div>
//                 <div style={statCardStyle}>
//                     <div style={{...statIconWrapperStyle, background: '#FEE2E2'}}>
//                         <FaTimes style={{color: '#DC2626'}} size={20} />
//                     </div>
//                     <div>
//                         <div style={statNumberStyle}>{getStatusCount('rejected')}</div>
//                         <div style={statLabelStyle}>Rejected</div>
//                     </div>
//                 </div>
//             </div>

//             {/* Search and Filter */}
//             <div style={searchFilterContainerStyle}>
//                 <div style={searchContainerStyle}>
//                     <FaSearch style={searchIconStyle} />
//                     <input
//                         type="text"
//                         placeholder="Search by customer, company, email..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         style={searchInputStyle}
//                     />
//                 </div>
//                 <div style={filterContainerStyle}>
//                     <FaFilter style={filterIconStyle} />
//                     <select
//                         value={filterStatus}
//                         onChange={(e) => setFilterStatus(e.target.value)}
//                         style={filterSelectStyle}
//                     >
//                         <option value="all">All Status</option>
//                         <option value="pending">Pending</option>
//                         <option value="quoted">Quoted</option>
//                         <option value="approved">Approved</option>
//                         <option value="rejected">Rejected</option>
//                     </select>
//                 </div>
//             </div>

//             {/* Table */}
//             <div style={tableCardStyle}>
//                 {loading ? (
//                     <div style={loadingStyle}>
//                         <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={32} color="#4F46E5" />
//                         <p>Loading quotations...</p>
//                     </div>
//                 ) : (
//                     <div style={tableWrapperStyle}>
//                         <table style={tableStyle}>
//                             <thead>
//                                 <tr>
//                                     <th style={{...thStyle, width: '4%', textAlign: 'center' }}>S.No</th>
//                                     <th style={{...thStyle, width: '12%', textAlign: 'left' }}>Customer</th>
//                                     <th style={{...thStyle, width: '8%', textAlign: 'center' }}>Event</th>
//                                     <th style={{...thStyle, width: '10%', textAlign: 'center' }}>Date</th>
//                                     <th style={{...thStyle, width: '7%', textAlign: 'center' }}>Plates</th>
//                                     <th style={{...thStyle, width: '9%', textAlign: 'center' }}>Budget</th>
//                                     <th style={{ ...thStyle,width: '9%', textAlign: 'center' }}>Quoted</th>
//                                     <th style={{...thStyle, width: '8%', textAlign: 'center' }}>Status</th>
//                                     <th style={{...thStyle, width: '10%', textAlign: 'center' }}>Vendors</th>
//                                     <th style={{...thStyle, width: '23%', textAlign: 'center' }}>Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {filteredQuotations.length === 0 ? (
//                                     <tr>
//                                         <td colSpan="10" style={emptyStateStyle}>
//                                             <div style={emptyStateContentStyle}>
//                                                 <FaDollarSign size={40} color="#D1D5DB" />
//                                                 <p>No quotations found</p>
//                                                 <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
//                                                     {quotations.length === 0 ? 'No approved leads available' : 'Try adjusting your search or filter'}
//                                                 </span>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ) : (
//                                     filteredQuotations.map((quotation, index) => (
//                                         <tr key={quotation.id} style={tableRowStyle}>
//                                             <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 500, color: '#9CA3AF' }}>
//                                                 {index + 1}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'left' }}>
//                                                 <div style={customerCellStyle}>
//                                                     <div style={avatarStyle}>
//                                                         {(quotation.customerName || '?')[0].toUpperCase()}
//                                                     </div>
//                                                     <div>
//                                                         <div style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>
//                                                             {quotation.customerName}
//                                                         </div>
//                                                         <div style={{ fontSize: '12px', color: '#6B7280' }}>
//                                                             {quotation.companyName}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 <span style={eventBadgeStyle}>{quotation.eventType}</span>
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center', fontSize: '13px', color: '#374151' }}>
//                                                 {quotation.eventDate}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 <span style={platesBadgeStyle}>{quotation.totalPlates}</span>
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#059669' }}>
//                                                 ₹{quotation.estimatedBudget.toLocaleString()}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 {quotation.quotedAmount ? (
//                                                     <span style={quotedAmountStyle}>
//                                                         ₹{quotation.quotedAmount.toLocaleString()}
//                                                     </span>
//                                                 ) : (
//                                                     <span style={{ color: '#bbb' }}>—</span>
//                                                 )}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 {getStatusBadge(quotation.status)}
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 <div style={vendorsContainerStyle}>
//                                                     {quotation.vendors.map((v, i) => (
//                                                         <span key={i} style={vendorTagStyle}>{v}</span>
//                                                     ))}
//                                                 </div>
//                                             </td>
//                                             <td style={{ ...tdStyle, textAlign: 'center' }}>
//                                                 <div style={actionGroupStyle}>
//                                                     <button
//                                                         onClick={() => handleViewQuotation(quotation)}
//                                                         style={viewButtonStyle}
//                                                         title="View"
//                                                     >
//                                                         <FaEye size={13} />
//                                                     </button>
//                                                     {quotation.status === 'pending' && (
//                                                         <>
//                                                             <button
//                                                                 onClick={() => handleOpenSendModal(quotation)}
//                                                                 style={sendButtonStyle}
//                                                                 title="Send to Vendors"
//                                                             >
//                                                                 <FaPaperPlane size={13} />
//                                                             </button>
//                                                             <button
//                                                                 onClick={() => handleApprove(quotation.id)}
//                                                                 style={approveButtonStyle}
//                                                                 title="Approve"
//                                                             >
//                                                                 <FaCheck size={13} />
//                                                             </button>
//                                                             <button
//                                                                 onClick={() => handleReject(quotation.id)}
//                                                                 style={rejectButtonStyle}
//                                                                 title="Reject"
//                                                             >
//                                                                 <FaTimes size={13} />
//                                                             </button>
//                                                         </>
//                                                     )}
//                                                     <button
//                                                         onClick={() => handlePrint(quotation)}
//                                                         style={printButtonStyle}
//                                                         title="Print"
//                                                     >
//                                                         <FaPrint size={13} />
//                                                     </button>
//                                                     <button
//                                                         onClick={() => handleExportPDF(quotation)}
//                                                         style={pdfButtonStyle}
//                                                         title="Export PDF"
//                                                     >
//                                                         <FaFilePdf size={13} />
//                                                     </button>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     ))
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}
//             </div>

//             {/* View Quotation Modal */}
//             {showViewModal && selectedQuotation && (
//                 <div style={modalOverlayStyle} onClick={() => setShowViewModal(false)}>
//                     <div style={{ ...modalStyle, maxWidth: '800px' }} onClick={(e) => e.stopPropagation()}>
//                         <div style={modalHeaderStyle}>
//                             <div style={modalHeaderLeftStyle}>
//                                 <div style={modalHeaderIconStyle}>
//                                     <FaDollarSign size={18} />
//                                 </div>
//                                 <h3 style={modalTitleStyle}>
//                                     Quotation #{selectedQuotation.id}
//                                 </h3>
//                             </div>
//                             <button
//                                 onClick={() => setShowViewModal(false)}
//                                 style={modalCloseStyle}
//                             >
//                                 <FaTimes />
//                             </button>
//                         </div>

//                         <div style={modalBodyStyle}>
//                             {/* Customer Info */}
//                             <div style={quotationHeaderStyle}>
//                                 <div style={quotationHeaderLeftStyle}>
//                                     <div style={quotationCustomerStyle}>
//                                         <h4>{selectedQuotation.customerName}</h4>
//                                         <p>{selectedQuotation.companyName}</p>
//                                         <div style={contactInfoStyle}>
//                                             <span><FaEnvelope size={12} /> {selectedQuotation.email}</span>
//                                             <span><FaPhone size={12} /> {selectedQuotation.phone}</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div style={quotationHeaderRightStyle}>
//                                     <div style={quotationMetaStyle}>
//                                         <div><strong>Status:</strong> {getStatusBadge(selectedQuotation.status)}</div>
//                                         <div><strong>Created:</strong> {selectedQuotation.createdAt}</div>
//                                         <div><strong>Quoted:</strong> {selectedQuotation.quotationDate || '—'}</div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Event Details */}
//                             <div style={quotationEventStyle}>
//                                 <div style={quotationEventItemStyle}>
//                                     <FaCalendarAlt size={14} />
//                                     <span><strong>Event:</strong> {selectedQuotation.eventType}</span>
//                                 </div>
//                                 <div style={quotationEventItemStyle}>
//                                     <FaCalendarAlt size={14} />
//                                     <span><strong>Date:</strong> {selectedQuotation.eventDate}</span>
//                                 </div>
//                                 <div style={quotationEventItemStyle}>
//                                     <FaMapMarkerAlt size={14} />
//                                     <span><strong>Location:</strong> {selectedQuotation.city}</span>
//                                 </div>
//                             </div>

//                             {/* Items Table */}
//                             <div style={quotationItemsStyle}>
//                                 <h4 style={itemsTitleStyle}>Menu Items</h4>
//                                 <table style={itemsTableStyle}>
//                                     <thead>
//                                         <tr>
//                                             <th style={{ textAlign: 'left' }}>Item</th>
//                                             <th style={{ textAlign: 'center' }}>Quantity</th>
//                                             <th style={{ textAlign: 'center' }}>Price (₹)</th>
//                                             <th style={{ textAlign: 'right' }}>Total (₹)</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {selectedQuotation.items.map((item, idx) => (
//                                             <tr key={idx}>
//                                                 <td>{item.name}</td>
//                                                 <td style={{ textAlign: 'center' }}>{item.quantity}</td>
//                                                 <td style={{ textAlign: 'center' }}>₹{item.price}</td>
//                                                 <td style={{ textAlign: 'right' }}>₹{(item.quantity * item.price).toLocaleString()}</td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                     <tfoot>
//                                         <tr>
//                                             <td colSpan="3" style={{ textAlign: 'right', fontWeight: 600 }}>Total:</td>
//                                             <td style={{ textAlign: 'right', fontWeight: 700, color: '#e66d33' }}>
//                                                 ₹{(selectedQuotation.items.reduce((sum, item) => sum + (item.quantity * item.price), 0)).toLocaleString()}
//                                             </td>
//                                         </tr>
//                                     </tfoot>
//                                 </table>
//                             </div>

//                             {/* Vendors */}
//                             <div style={quotationVendorsStyle}>
//                                 <strong>Vendors:</strong>
//                                 {selectedQuotation.vendors.map((v, i) => (
//                                     <span key={i} style={vendorTagLargeStyle}>{v}</span>
//                                 ))}
//                             </div>

//                             {/* Summary */}
//                             <div style={quotationSummaryStyle}>
//                                 <div style={summaryRowStyle}>
//                                     <span>Estimated Budget:</span>
//                                     <span style={summaryValueStyle}>₹{selectedQuotation.estimatedBudget.toLocaleString()}</span>
//                                 </div>
//                                 {selectedQuotation.quotedAmount && (
//                                     <div style={summaryRowStyle}>
//                                         <span>Quoted Amount:</span>
//                                         <span style={quotedSummaryValueStyle}>₹{selectedQuotation.quotedAmount.toLocaleString()}</span>
//                                     </div>
//                                 )}
//                                 <div style={summaryRowStyle}>
//                                     <span>Total Plates:</span>
//                                     <span>{selectedQuotation.totalPlates}</span>
//                                 </div>
//                             </div>

//                             {/* Action Buttons */}
//                             <div style={formActionStyle}>
//                                 <button
//                                     onClick={() => setShowViewModal(false)}
//                                     style={cancelButtonStyle}
//                                 >
//                                     Close
//                                 </button>
//                                 <button
//                                     onClick={() => handlePrint(selectedQuotation)}
//                                     style={printLargeButtonStyle}
//                                 >
//                                     <FaPrint size={14} />
//                                     Print
//                                 </button>
//                                 <button
//                                     onClick={() => handleExportPDF(selectedQuotation)}
//                                     style={pdfLargeButtonStyle}
//                                 >
//                                     <FaFilePdf size={14} />
//                                     Export PDF
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Send to Vendors Modal */}
//             {showSendModal && selectedQuotation && (
//                 <div style={modalOverlayStyle} onClick={() => setShowSendModal(false)}>
//                     <div style={{ ...modalStyle, maxWidth: '550px' }} onClick={(e) => e.stopPropagation()}>
//                         <div style={modalHeaderStyle}>
//                             <div style={modalHeaderLeftStyle}>
//                                 <div style={modalHeaderIconStyle}>
//                                     <FaPaperPlane size={18} />
//                                 </div>
//                                 <h3 style={modalTitleStyle}>Send Quotation to Vendors</h3>
//                             </div>
//                             <button
//                                 onClick={() => setShowSendModal(false)}
//                                 style={modalCloseStyle}
//                             >
//                                 <FaTimes />
//                             </button>
//                         </div>

//                         <div style={modalBodyStyle}>
//                             <div style={sendInfoStyle}>
//                                 <p><strong>Customer:</strong> {selectedQuotation.customerName}</p>
//                                 <p><strong>Event:</strong> {selectedQuotation.eventType} - {selectedQuotation.eventDate}</p>
//                                 <p><strong>Budget:</strong> ₹{selectedQuotation.estimatedBudget.toLocaleString()}</p>
//                             </div>

//                             <div style={vendorSelectAllStyle}>
//                                 <label style={checkboxLabelStyle}>
//                                     <input
//                                         type="checkbox"
//                                         checked={selectAll}
//                                         onChange={handleSelectAll}
//                                     />
//                                     <strong>Select All Vendors</strong>
//                                 </label>
//                             </div>

//                             <div style={vendorListStyle}>
//                                 {vendors.map(vendor => (
//                                     <div key={vendor.id} style={vendorItemStyle}>
//                                         <label style={checkboxLabelStyle}>
//                                             <input
//                                                 type="checkbox"
//                                                 checked={selectedVendors[vendor.id] || false}
//                                                 onChange={() => handleVendorSelect(vendor.id)}
//                                             />
//                                             <div>
//                                                 <div style={{ fontWeight: 600 }}>{vendor.name}</div>
//                                                 <div style={{ fontSize: '12px', color: '#888' }}>{vendor.email}</div>
//                                             </div>
//                                         </label>
//                                     </div>
//                                 ))}
//                             </div>

//                             <div style={formActionStyle}>
//                                 <button
//                                     type="button"
//                                     onClick={() => setShowSendModal(false)}
//                                     style={cancelButtonStyle}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     onClick={handleSendToVendors}
//                                     style={sendButtonLargeStyle}
//                                 >
//                                     <FaPaperPlane size={14} />
//                                     Send to Selected Vendors
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             <style>{`
//                 @keyframes spin { to { transform: rotate(360deg); } }
//             `}</style>
//         </div>
//     );
// };

// // ─── Styles ──────────────────────────────────────────────────────

// const containerStyle = {
  
// };

// const headerStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '24px',
//     flexWrap: 'wrap',
//     gap: '16px',
// };

// const headerLeftStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
// };

// const headerIconStyle = {
//     width: '44px',
//     height: '44px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     borderRadius: '12px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     color: '#fff',
// };

// const titleStyle = {
//     fontSize: '24px',
//     fontWeight: 700,
//     color: '#111827',
//     margin: 0,
//     letterSpacing: '-0.5px',
// };

// const subtitleStyle = {
//     fontSize: '14px',
//     color: '#6B7280',
//     margin: '4px 0 0 0',
// };

// const headerRightStyle = {
//     display: 'flex',
//     gap: '10px',
// };

// const refreshButtonStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '6px',
//     padding: '10px 18px',
//     background: '#fff',
//     color: '#4B5563',
//     border: '1px solid #E5E7EB',
//     borderRadius: '10px',
//     fontWeight: 500,
//     fontSize: '13px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// const exportAllButtonStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px 20px',
//     background: '#dc3545',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '10px',
//     fontWeight: 600,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// const statsContainerStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(4, 1fr)',
//     gap: '16px',
//     marginBottom: '24px',
// };

// const statCardStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
//     background: '#fff',
//     padding: '18px 20px',
//     borderRadius: '12px',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
//     border: '1px solid #E5E7EB',
//     transition: 'all 0.2s ease',
// };

// const statIconWrapperStyle = {
//     width: '44px',
//     height: '44px',
//     borderRadius: '10px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
// };

// const statNumberStyle = {
//     fontSize: '22px',
//     fontWeight: 700,
//     color: '#111827',
//     lineHeight: 1.2,
// };

// const statLabelStyle = {
//     fontSize: '13px',
//     color: '#6B7280',
//     fontWeight: 500,
// };

// // ─── Search & Filter Styles ─────────────────────────────────────

// const searchFilterContainerStyle = {
//     display: 'flex',
//     gap: '12px',
//     marginBottom: '20px',
//     flexWrap: 'wrap',
// };

// const searchContainerStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     flex: 1,
//     minWidth: '200px',
//     background: '#fff',
//     border: '1px solid #E5E7EB',
//     borderRadius: '10px',
//     padding: '0 16px',
//     transition: 'all 0.2s ease',
// };

// const searchIconStyle = {
//     color: '#9CA3AF',
//     marginRight: '10px',
// };

// const searchInputStyle = {
//     flex: 1,
//     padding: '11px 0',
//     border: 'none',
//     outline: 'none',
//     fontSize: '14px',
//     background: 'transparent',
//     color: '#111827',
// };

// const filterContainerStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     background: '#fff',
//     border: '1px solid #E5E7EB',
//     borderRadius: '10px',
//     padding: '0 14px',
// };

// const filterIconStyle = {
//     color: '#6B7280',
//     marginRight: '10px',
//     fontSize: '13px',
// };

// const filterSelectStyle = {
//     padding: '11px 8px',
//     border: 'none',
//     outline: 'none',
//     fontSize: '14px',
//     background: 'transparent',
//     cursor: 'pointer',
//     color: '#111827',
// };

// // ─── Table Styles ──────────────────────────────────────────────

// const tableCardStyle = {
//     background: '#fff',
//     borderRadius: '12px',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
//     overflow: 'hidden',
//     border: '1px solid #E5E7EB',
// };

// const tableWrapperStyle = {
//      overflowX: 'auto',
//     padding: '0',
//     maxHeight: "50vh",
//     scrollbarWidth: "thin",
// };

// const tableStyle = {
//     width: '100%',
//     borderCollapse: 'collapse',
//     minWidth: '1100px',
// };
// const thStyle = {
//     padding: '12px 16px',
//     fontSize: '12px',
//     fontWeight: 600,
//     color: '#6B7280',
//     textTransform: 'uppercase',
//     letterSpacing: '0.5px',
//     background: '#F9FAFB',
//     borderBottom: '1px solid #E5E7EB',
// };
// const tdStyle = {
//     padding: '12px 16px',
//     fontSize: '13px',
//     color: '#111827',
//     borderBottom: '1px solid #F3F4F6',
// };

// const tableRowStyle = {
//     transition: 'background 0.15s ease',
//     cursor: 'default',
// };

// const emptyStateStyle = {
//     padding: '60px 20px',
//     textAlign: 'center',
//     borderBottom: 'none',
// };

// const emptyStateContentStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: '8px',
// };

// const loadingStyle = {
//     padding: '60px 20px',
//     textAlign: 'center',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     gap: '12px',
//     color: '#6B7280',
// };

// // ─── Badge Styles ──────────────────────────────────────────────

// const platesBadgeStyle = {
//     display: 'inline-block',
//     padding: '2px 10px',
//     background: 'rgba(230, 126, 34, 0.1)',
//     borderRadius: '12px',
//     fontSize: '12px',
//     fontWeight: 600,
//     color: '#e66d33',
// };

// const pendingBadgeStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '4px',
//     padding: '4px 12px',
//     background: '#FEF3C7',
//     borderRadius: '20px',
//     fontSize: '11px',
//     fontWeight: 600,
//     color: '#92400E',
// };

// const approvedBadgeStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '4px',
//     padding: '4px 12px',
//     background: '#D1FAE5',
//     borderRadius: '20px',
//     fontSize: '11px',
//     fontWeight: 600,
//     color: '#065F46',
// };

// const rejectedBadgeStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '4px',
//     padding: '4px 12px',
//     background: '#FEE2E2',
//     borderRadius: '20px',
//     fontSize: '11px',
//     fontWeight: 600,
//     color: '#991B1B',
// };

// const quotedBadgeStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '4px',
//     padding: '4px 12px',
//     background: '#E0E7FF',
//     borderRadius: '20px',
//     fontSize: '11px',
//     fontWeight: 600,
//     color: '#3730A3',
// };

// const eventBadgeStyle = {
//     display: 'inline-block',
//     padding: '2px 10px',
//     background: '#F3F4F6',
//     borderRadius: '6px',
//     fontSize: '12px',
//     fontWeight: 500,
//     color: '#4B5563',
// };

// const quotedAmountStyle = {
//     fontWeight: 600,
//     color: '#059669',
// };

// // ─── Customer Cell ──────────────────────────────────────────────

// const customerCellStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
// };

// const avatarStyle = {
//     width: '32px',
//     height: '32px',
//     borderRadius: '50%',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     color: '#fff',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '13px',
//     fontWeight: 600,
//     flexShrink: 0,
// };

// // ─── Vendor Tags ──────────────────────────────────────────────

// const vendorsContainerStyle = {
//     display: 'flex',
//     flexWrap: 'wrap',
//     gap: '4px',
//     justifyContent: 'center',
// };

// const vendorTagStyle = {
//     padding: '2px 8px',
//     background: '#F3F4F6',
//     borderRadius: '4px',
//     fontSize: '10px',
//     color: '#4B5563',
// };

// const vendorTagLargeStyle = {
//     display: 'inline-block',
//     padding: '4px 12px',
//     background: '#F3F4F6',
//     borderRadius: '6px',
//     fontSize: '13px',
//     color: '#4B5563',
//     marginRight: '6px',
// };

// // ─── Action Buttons ─────────────────────────────────────────────

// const actionGroupStyle = {
//     display: 'flex',
//     gap: '6px',
//     flexWrap: 'wrap',
//     justifyContent: 'center',
// };

// const viewButtonStyle = {
//     padding: '6px 10px',
//     background: '#DBEAFE',
//     color: '#1D4ED8',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     fontSize: '13px',
// };

// const sendButtonStyle = {
//     padding: '6px 10px',
//     background: '#D1FAE5',
//     color: '#065F46',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     fontSize: '13px',
// };

// const approveButtonStyle = {
//     padding: '6px 10px',
//     background: '#D1FAE5',
//     color: '#059669',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     fontSize: '13px',
// };

// const rejectButtonStyle = {
//     padding: '6px 10px',
//     background: '#FEE2E2',
//     color: '#DC2626',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     fontSize: '13px',
// };

// const printButtonStyle = {
//     padding: '6px 10px',
//     background: '#F3F4F6',
//     color: '#4B5563',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     fontSize: '13px',
// };

// const pdfButtonStyle = {
//     padding: '6px 10px',
//     background: '#FEE2E2',
//     color: '#DC2626',
//     border: 'none',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     fontSize: '13px',
// };

// // ─── Modal Styles ──────────────────────────────────────────────

// const modalOverlayStyle = {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'rgba(0,0,0,0.5)',
//     backdropFilter: 'blur(4px)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 9999,
//     padding: '20px',
// };

// const modalStyle = {
//     background: '#fff',
//     borderRadius: '16px',
//     width: '100%',
//     maxWidth: '700px',
//     maxHeight: '90vh',
//     overflow: 'auto',
//     boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
// };

// const modalHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '20px 24px',
//     borderBottom: '1px solid #F3F4F6',
//     position: 'sticky',
//     top: 0,
//     background: '#fff',
//     zIndex: 1,
// };

// const modalHeaderLeftStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
// };

// const modalHeaderIconStyle = {
//     width: '36px',
//     height: '36px',
//     borderRadius: '10px',
//     background: 'linear-gradient(135deg, #e66d33, #e66d33)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     color: '#fff',
// };

// const modalTitleStyle = {
//     margin: 0,
//     fontSize: '18px',
//     fontWeight: 700,
//     color: '#111827',
// };

// const modalCloseStyle = {
//     background: '#F3F4F6',
//     border: 'none',
//     fontSize: '16px',
//     cursor: 'pointer',
//     color: '#6B7280',
//     padding: '6px 10px',
//     borderRadius: '8px',
//     transition: 'all 0.2s ease',
// };

// const modalBodyStyle = {
//     padding: '24px',
// };

// // ─── Quotation View Styles ─────────────────────────────────────

// const quotationHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     padding: '16px',
//     background: '#F9FAFB',
//     borderRadius: '10px',
//     marginBottom: '16px',
//     flexWrap: 'wrap',
//     gap: '12px',
// };

// const quotationHeaderLeftStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
// };

// const quotationCustomerStyle = {
//     '& h4': {
//         margin: 0,
//         fontSize: '16px',
//         fontWeight: 700,
//         color: '#111827',
//     },
//     '& p': {
//         margin: '2px 0',
//         fontSize: '14px',
//         color: '#6B7280',
//     },
// };

// const contactInfoStyle = {
//     display: 'flex',
//     gap: '16px',
//     marginTop: '4px',
//     '& span': {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '4px',
//         fontSize: '13px',
//         color: '#6B7280',
//     },
// };

// const quotationHeaderRightStyle = {
//     display: 'flex',
//     alignItems: 'center',
// };

// const quotationMetaStyle = {
//     fontSize: '13px',
//     color: '#6B7280',
//     '& div': {
//         marginBottom: '2px',
//     },
// };

// const quotationEventStyle = {
//     display: 'flex',
//     gap: '20px',
//     padding: '12px 16px',
//     background: '#fff',
//     borderRadius: '8px',
//     border: '1px solid #F3F4F6',
//     marginBottom: '16px',
//     flexWrap: 'wrap',
// };

// const quotationEventItemStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '6px',
//     fontSize: '14px',
//     color: '#374151',
// };

// const quotationItemsStyle = {
//     marginBottom: '16px',
// };

// const itemsTitleStyle = {
//     margin: '0 0 8px 0',
//     fontSize: '15px',
//     fontWeight: 600,
//     color: '#111827',
// };

// const itemsTableStyle = {
//     width: '100%',
//     borderCollapse: 'collapse',
//     fontSize: '13px',
// };

// const quotationVendorsStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '12px 16px',
//     background: '#F9FAFB',
//     borderRadius: '8px',
//     marginBottom: '16px',
//     flexWrap: 'wrap',
// };

// const quotationSummaryStyle = {
//     padding: '16px',
//     background: '#fff',
//     borderRadius: '8px',
//     border: '1px solid #F3F4F6',
//     marginBottom: '16px',
// };

// const summaryRowStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     padding: '4px 0',
//     fontSize: '14px',
// };

// const summaryValueStyle = {
//     fontWeight: 600,
//     color: '#111827',
// };

// const quotedSummaryValueStyle = {
//     fontWeight: 700,
//     color: '#059669',
// };

// // ─── Form Action Styles ────────────────────────────────────────

// const formActionStyle = {
//     display: 'flex',
//     gap: '12px',
//     justifyContent: 'flex-end',
//     marginTop: '16px',
//     paddingTop: '16px',
//     borderTop: '1px solid #F3F4F6',
// };

// const cancelButtonStyle = {
//     padding: '10px 24px',
//     background: '#F3F4F6',
//     color: '#4B5563',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 500,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// const printLargeButtonStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px 24px',
//     background: '#6B7280',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 600,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// const pdfLargeButtonStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px 24px',
//     background: '#DC2626',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// // ─── Send Modal Styles ──────────────────────────────────────────

// const sendInfoStyle = {
//     background: '#F9FAFB',
//     padding: '12px 16px',
//     borderRadius: '8px',
//     marginBottom: '16px',
//     '& p': {
//         margin: '4px 0',
//         fontSize: '14px',
//     },
// };

// const vendorSelectAllStyle = {
//     padding: '12px 0',
//     borderBottom: '1px solid #F3F4F6',
//     marginBottom: '12px',
// };

// const vendorListStyle = {
//     maxHeight: '250px',
//     overflowY: 'auto',
//     marginBottom: '16px',
// };

// const vendorItemStyle = {
//     padding: '10px 12px',
//     borderBottom: '1px solid #F3F4F6',
// };

// const checkboxLabelStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
//     cursor: 'pointer',
//     fontSize: '14px',
// };

// const sendButtonLargeStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px 24px',
//     background: '#059669',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '14px',
//     fontWeight: 600,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
// };

// export default SalesQuotation;



// SalesQuotation.jsx - With Date Filter and Expandable Rows
import React, { useState, useEffect } from 'react';
import { 
    FaEye, FaEdit, FaTrash, FaCheck, FaTimes, 
    FaFilePdf, FaPrint, FaSearch, FaFilter,
    FaCheckCircle, FaClock, FaExclamationCircle,
    FaDollarSign, FaUser, FaCalendarAlt, FaMapMarkerAlt,
    FaBuilding, FaPhone, FaEnvelope, FaPaperPlane,
    FaPlus, FaSpinner, FaSync, FaChevronDown, FaChevronRight
} from 'react-icons/fa';
import { getAllEnquiries } from '../../Servicefile/salesService';

const SalesQuotation = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('all');
    const [showViewModal, setShowViewModal] = useState(false);
    const [showSendModal, setShowSendModal] = useState(false);
    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const [selectedVendors, setSelectedVendors] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [quotations, setQuotations] = useState([]);
    const [filteredQuotations, setFilteredQuotations] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    
    // Date filter states
    const [dateFilter, setDateFilter] = useState('all');
    const [customStartDate, setCustomStartDate] = useState('');
    const [customEndDate, setCustomEndDate] = useState('');
    const [showCustomDateModal, setShowCustomDateModal] = useState(false);

    // Vendor list for send modal
    const vendors = [
        { id: 1, name: 'Vendor A', email: 'vendorA@example.com', city: 'Hyderabad' },
        { id: 2, name: 'Vendor B', email: 'vendorB@example.com', city: 'Mumbai' },
        { id: 3, name: 'Vendor C', email: 'vendorC@example.com', city: 'Delhi' },
        { id: 4, name: 'Vendor D', email: 'vendorD@example.com', city: 'Bangalore' },
        { id: 5, name: 'Vendor E', email: 'vendorE@example.com', city: 'Chennai' },
    ];

    // Date filter helper functions
    const getDateRange = (filterType) => {
        const today = new Date();
        const start = new Date();
        const end = new Date();

        switch (filterType) {
            case 'today':
                start.setHours(0, 0, 0, 0);
                end.setHours(23, 59, 59, 999);
                break;
            case 'yesterday':
                start.setDate(today.getDate() - 1);
                start.setHours(0, 0, 0, 0);
                end.setDate(today.getDate() - 1);
                end.setHours(23, 59, 59, 999);
                break;
            case 'week':
                const day = today.getDay();
                start.setDate(today.getDate() - day);
                start.setHours(0, 0, 0, 0);
                end.setDate(today.getDate() + (6 - day));
                end.setHours(23, 59, 59, 999);
                break;
            case 'month':
                start.setDate(1);
                start.setHours(0, 0, 0, 0);
                end.setHours(23, 59, 59, 999);
                break;
            case 'custom':
                if (customStartDate && customEndDate) {
                    return { from: new Date(customStartDate), to: new Date(customEndDate) };
                }
                return null;
            default:
                return null;
        }
        return { from: start, to: end };
    };

    const applyDateFilter = (quotationsList) => {
        if (dateFilter === 'all') return quotationsList;

        const range = getDateRange(dateFilter);
        if (!range) return quotationsList;

        return quotationsList.filter(q => {
            const dateStr = q.createdAt || q.eventDate;
            if (!dateStr) return false;
            const enquiryDate = new Date(dateStr);
            return enquiryDate >= range.from && enquiryDate <= range.to;
        });
    };

    // Generate vendor quotations for a lead
    const generateVendorQuotations = (lead) => {
        const vendorNames = ['Vendor A', 'Vendor B', 'Vendor C', 'Vendor D', 'Vendor E'];
        const numVendors = Math.floor(Math.random() * 3) + 2; // 2-4 vendors
        const shuffled = [...vendorNames].sort(() => 0.5 - Math.random());
        const selectedVendors = shuffled.slice(0, numVendors);
        
        return selectedVendors.map((vendor, index) => {
            const statuses = ['pending', 'quoted', 'approved', 'rejected'];
            const status = statuses[Math.floor(Math.random() * statuses.length)];
            const amount = Math.round((lead.budget || 0) * (0.7 + Math.random() * 0.5));
            
            return {
                id: index + 1,
                vendorName: vendor,
                quotedAmount: amount,
                status: status,
                quotationDate: new Date(Date.now() - Math.random() * 7 * 24 * 60 * 60 * 1000).toLocaleDateString(),
                items: generateItems()
            };
        });
    };

    const generateItems = () => {
        const dishNames = ['Veg Biryani', 'Chicken Biryani', 'Paneer Butter Masala', 'Butter Chicken', 'Gulab Jamun', 'Naan', 'Pizza', 'Pasta'];
        const numItems = Math.floor(Math.random() * 3) + 2;
        const items = [];
        for (let i = 0; i < numItems; i++) {
            const randomIndex = Math.floor(Math.random() * dishNames.length);
            const quantity = Math.floor(Math.random() * 50) + 10;
            const price = Math.floor(Math.random() * 100) + 50;
            items.push({
                name: dishNames[randomIndex],
                quantity: quantity,
                price: price
            });
        }
        return items;
    };

    // Static quotation data for each lead
    const generateQuotationForLead = (lead) => {
        const vendorQuotations = generateVendorQuotations(lead);
        
        return {
            id: lead.id || lead.enquiryId,
            enquiryId: lead.id || lead.enquiryId,
            customerName: lead.fullName || 'Unknown Customer',
            companyName: lead.companyName || 'N/A',
            email: lead.email || 'N/A',
            phone: lead.phoneNumber || 'N/A',
            eventType: lead.eventType || 'Event',
            eventDate: lead.eventDate || lead.fromDate || 'N/A',
            city: lead.city || 'N/A',
            totalPlates: (lead.vegPlates || 0) + (lead.nonVegPlates || 0) + (lead.mixedPlates || 0),
            estimatedBudget: lead.budget || 0,
            createdAt: lead.createdAt ? new Date(lead.createdAt).toLocaleDateString() : 'N/A',
            vendorQuotations: vendorQuotations,
            leadData: lead
        };
    };

    // Fetch approved leads
    const fetchApprovedLeads = async () => {
        setLoading(true);
        try {
            const data = await getAllEnquiries();
            const approvedLeads = data.filter(lead => lead.leadStatus === 'APPROVED');
            
            setLeads(approvedLeads);
            
            const generatedQuotations = approvedLeads.map(lead => generateQuotationForLead(lead));
            setQuotations(generatedQuotations);
            
            // Apply filters
            let filtered = generatedQuotations;
            if (searchTerm) {
                filtered = filtered.filter(q => 
                    q.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    q.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    q.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    q.eventType.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
            filtered = applyDateFilter(filtered);
            setFilteredQuotations(filtered);
            
        } catch (error) {
            console.error('❌ Error fetching approved leads:', error);
            alert('Failed to fetch approved leads');
        } finally {
            setLoading(false);
        }
    };

    // Fetch on mount
    useEffect(() => {
        fetchApprovedLeads();
    }, []);

    // Filter quotations
    useEffect(() => {
        let filtered = quotations;
        
        if (searchTerm) {
            filtered = filtered.filter(q => 
                q.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                q.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                q.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                q.eventType.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        
        filtered = applyDateFilter(filtered);
        setFilteredQuotations(filtered);
    }, [searchTerm, dateFilter, customStartDate, customEndDate, quotations]);

    // Get status badge
    const getStatusBadge = (status) => {
        switch(status) {
            case 'pending':
                return <span style={pendingBadgeStyle}><FaClock size={12} /> Pending</span>;
            case 'approved':
                return <span style={approvedBadgeStyle}><FaCheckCircle size={12} /> Approved</span>;
            case 'rejected':
                return <span style={rejectedBadgeStyle}><FaTimes size={12} /> Rejected</span>;
            case 'quoted':
                return <span style={quotedBadgeStyle}><FaDollarSign size={12} /> Quoted</span>;
            default:
                return <span style={pendingBadgeStyle}>Unknown</span>;
        }
    };

    // Toggle row expansion
    const toggleRow = (id) => {
        setExpandedRows(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    // Handle view quotation
    const handleViewQuotation = (vendorQuotation, customerName) => {
        setSelectedQuotation({
            ...vendorQuotation,
            customerName: customerName
        });
        setShowViewModal(true);
    };

    // Handle send to vendors
    const handleSendToVendors = () => {
        const selected = Object.keys(selectedVendors).filter(key => selectedVendors[key]);
        if (selected.length === 0) {
            alert('Please select at least one vendor');
            return;
        }
        
        setShowSendModal(false);
        setSelectedVendors({});
        setSelectAll(false);
        alert(`Quotation sent to ${selected.length} vendor(s)`);
    };

    // Handle open send modal
    const handleOpenSendModal = (quotation) => {
        setSelectedQuotation(quotation);
        setSelectedVendors({});
        setSelectAll(false);
        setShowSendModal(true);
    };

    // Handle select all vendors
    const handleSelectAll = () => {
        const newState = {};
        vendors.forEach(v => newState[v.id] = !selectAll);
        setSelectedVendors(newState);
        setSelectAll(!selectAll);
    };

    // Handle individual vendor selection
    const handleVendorSelect = (vendorId) => {
        setSelectedVendors(prev => ({
            ...prev,
            [vendorId]: !prev[vendorId]
        }));
    };

    // Handle refresh
    const handleRefresh = () => {
        fetchApprovedLeads();
    };

    // Handle custom date apply
    const handleCustomDateApply = () => {
        if (customStartDate && customEndDate) {
            setDateFilter('custom');
            setShowCustomDateModal(false);
        } else {
            alert('Please select both start and end dates');
        }
    };

    return (
        <div style={containerStyle}>
            {/* Header */}
            <div style={headerStyle}>
                <div style={headerLeftStyle}>
                    <div style={headerIconStyle}>
                        <FaDollarSign size={22} />
                    </div>
                    <div>
                        <h2 style={titleStyle}>Quotations</h2>
                        <p style={subtitleStyle}>Manage quotations for approved leads</p>
                    </div>
                </div>
                <div style={headerRightStyle}>
                    <button onClick={handleRefresh} style={refreshButtonStyle}>
                        <FaSync size={14} />
                        Refresh
                    </button>
                </div>
            </div>

            {/* Search and Filter */}
            <div style={searchFilterContainerStyle}>
                <div style={searchContainerStyle}>
                    <FaSearch style={searchIconStyle} />
                    <input
                        type="text"
                        placeholder="Search by customer, company, email..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={searchInputStyle}
                    />
                </div>

                {/* Date Filter */}
                <div style={dateFilterContainerStyle}>
                    <FaCalendarAlt style={filterIconStyle} />
                    <select
                        value={dateFilter}
                        onChange={(e) => {
                            const value = e.target.value;
                            setDateFilter(value);
                            if (value === 'custom') {
                                setShowCustomDateModal(true);
                            }
                        }}
                        style={filterSelectStyle}
                    >
                        <option value="all">All Dates</option>
                        <option value="today">Today</option>
                        <option value="yesterday">Yesterday</option>
                        <option value="week">This Week</option>
                        <option value="month">This Month</option>
                        <option value="custom">Custom Range</option>
                    </select>
                    <FaChevronDown style={{ color: '#9CA3AF', fontSize: '10px', marginLeft: '4px' }} />
                </div>

                {/* Custom Date Modal */}
                {showCustomDateModal && (
                    <div style={customDateModalOverlay} onClick={() => setShowCustomDateModal(false)}>
                        <div style={customDateModalStyle} onClick={(e) => e.stopPropagation()}>
                            <div style={customDateModalHeader}>
                                <h3 style={customDateModalTitle}>Select Custom Date Range</h3>
                                <button
                                    onClick={() => setShowCustomDateModal(false)}
                                    style={customDateModalClose}
                                >
                                    <FaTimes />
                                </button>
                            </div>
                            <div style={customDateModalBody}>
                                <div style={customDateModalInputGroup}>
                                    <label style={customDateModalLabel}>From Date</label>
                                    <input
                                        type="date"
                                        value={customStartDate}
                                        onChange={(e) => setCustomStartDate(e.target.value)}
                                        style={customDateModalInput}
                                        max={customEndDate || undefined}
                                    />
                                </div>
                                <div style={customDateModalInputGroup}>
                                    <label style={customDateModalLabel}>To Date</label>
                                    <input
                                        type="date"
                                        value={customEndDate}
                                        onChange={(e) => setCustomEndDate(e.target.value)}
                                        style={customDateModalInput}
                                        min={customStartDate || undefined}
                                    />
                                </div>
                            </div>
                            <div style={customDateModalFooter}>
                                <button
                                    onClick={() => {
                                        setShowCustomDateModal(false);
                                        setCustomStartDate('');
                                        setCustomEndDate('');
                                    }}
                                    style={customDateModalCancel}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleCustomDateApply}
                                    style={customDateModalApply}
                                >
                                    Apply Range
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Table */}
            <div style={tableCardStyle}>
                {loading ? (
                    <div style={loadingStyle}>
                        <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={32} color="#4F46E5" />
                        <p>Loading quotations...</p>
                    </div>
                ) : (
                    <div style={tableWrapperStyle}>
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={{...thStyle, width: '4%', textAlign: 'center' }}></th>
                                    <th style={{...thStyle, width: '12%', textAlign: 'left' }}>Customer</th>
                                    <th style={{...thStyle, width: '8%', textAlign: 'center' }}>Event</th>
                                    <th style={{...thStyle, width: '10%', textAlign: 'center' }}>Date</th>
                                    <th style={{...thStyle, width: '7%', textAlign: 'center' }}>Plates</th>
                                    <th style={{...thStyle, width: '9%', textAlign: 'center' }}>Budget</th>
                                    <th style={{...thStyle, width: '10%', textAlign: 'center' }}>Vendors</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredQuotations.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" style={emptyStateStyle}>
                                            <div style={emptyStateContentStyle}>
                                                <FaDollarSign size={40} color="#D1D5DB" />
                                                <p>No quotations found</p>
                                                <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
                                                    {quotations.length === 0 ? 'No approved leads available' : 'Try adjusting your search or filter'}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    filteredQuotations.map((quotation, index) => (
                                        <React.Fragment key={quotation.id}>
                                            {/* Main Row */}
                                            <tr style={tableRowStyle}>
                                                <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                    <button
                                                        onClick={() => toggleRow(quotation.id)}
                                                        style={expandButtonStyle}
                                                    >
                                                        {expandedRows[quotation.id] ? 
                                                            <FaChevronDown size={14} /> : 
                                                            <FaChevronRight size={14} />
                                                        }
                                                    </button>
                                                </td>
                                                <td style={{ ...tdStyle, textAlign: 'left' }}>
                                                    <div style={customerCellStyle}>
                                                        <div style={avatarStyle}>
                                                            {(quotation.customerName || '?')[0].toUpperCase()}
                                                        </div>
                                                        <div>
                                                            <div style={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>
                                                                {quotation.customerName}
                                                            </div>
                                                            <div style={{ fontSize: '12px', color: '#6B7280' }}>
                                                                {quotation.companyName}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                    <span style={eventBadgeStyle}>{quotation.eventType}</span>
                                                </td>
                                                <td style={{ ...tdStyle, textAlign: 'center', fontSize: '13px', color: '#374151' }}>
                                                    {quotation.eventDate}
                                                </td>
                                                <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                    <span style={platesBadgeStyle}>{quotation.totalPlates}</span>
                                                </td>
                                                <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 600, color: '#059669' }}>
                                                    ₹{quotation.estimatedBudget.toLocaleString()}
                                                </td>
                                                <td style={{ ...tdStyle, textAlign: 'center' }}>
                                                    <div style={vendorsContainerStyle}>
                                                        {quotation.vendorQuotations.map((vq, i) => (
                                                            <span key={i} style={vendorTagStyle}>
                                                                {vq.vendorName}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>

                                            {/* Expanded Row - Vendor Quotations */}
                                            {expandedRows[quotation.id] && (
                                                <tr>
                                                    <td colSpan="7" style={{ padding: 0 }}>
                                                        <div style={expandedContentStyle}>
                                                            <table style={subTableStyle}>
                                                                <thead>
                                                                    <tr style={subTableHeaderStyle}>
                                                                        <th style={{...subThStyle, width: '20%', textAlign: 'left'}}>Vendor</th>
                                                                        <th style={{...subThStyle, width: '20%', textAlign: 'center'}}>Quoted Amount</th>
                                                                        <th style={{...subThStyle, width: '15%', textAlign: 'center'}}>Status</th>
                                                                        <th style={{...subThStyle, width: '15%', textAlign: 'center'}}>Date</th>
                                                                        <th style={{...subThStyle, width: '30%', textAlign: 'center'}}>Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {quotation.vendorQuotations.map((vq, idx) => (
                                                                        <tr key={idx} style={subTableRowStyle}>
                                                                            <td style={{...subTdStyle, textAlign: 'left'}}>
                                                                                <span style={vendorNameStyle}>{vq.vendorName}</span>
                                                                            </td>
                                                                            <td style={{...subTdStyle, textAlign: 'center', fontWeight: 600, color: '#059669'}}>
                                                                                ₹{vq.quotedAmount.toLocaleString()}
                                                                            </td>
                                                                            <td style={{...subTdStyle, textAlign: 'center'}}>
                                                                                {getStatusBadge(vq.status)}
                                                                            </td>
                                                                            <td style={{...subTdStyle, textAlign: 'center', fontSize: '12px', color: '#6B7280'}}>
                                                                                {vq.quotationDate}
                                                                            </td>
                                                                            <td style={{...subTdStyle, textAlign: 'center'}}>
                                                                                <div style={actionGroupStyle}>
                                                                                    <button
                                                                                        onClick={() => handleViewQuotation(vq, quotation.customerName)}
                                                                                        style={viewButtonStyle}
                                                                                        title="View"
                                                                                    >
                                                                                        <FaEye size={13} />
                                                                                    </button>
                                                                                    {vq.status === 'pending' && (
                                                                                        <>
                                                                                            <button
                                                                                                onClick={() => handleOpenSendModal(vq)}
                                                                                                style={sendButtonStyle}
                                                                                                title="Send to Vendors"
                                                                                            >
                                                                                                <FaPaperPlane size={13} />
                                                                                            </button>
                                                                                            <button
                                                                                                style={approveButtonStyle}
                                                                                                title="Approve"
                                                                                            >
                                                                                                <FaCheck size={13} />
                                                                                            </button>
                                                                                            <button
                                                                                                style={rejectButtonStyle}
                                                                                                title="Reject"
                                                                                            >
                                                                                                <FaTimes size={13} />
                                                                                            </button>
                                                                                        </>
                                                                                    )}
                                                                                    <button
                                                                                        style={printButtonStyle}
                                                                                        title="Print"
                                                                                    >
                                                                                        <FaPrint size={13} />
                                                                                    </button>
                                                                                    <button
                                                                                        style={pdfButtonStyle}
                                                                                        title="Export PDF"
                                                                                    >
                                                                                        <FaFilePdf size={13} />
                                                                                    </button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* View Quotation Modal */}
            {showViewModal && selectedQuotation && (
                <div style={modalOverlayStyle} onClick={() => setShowViewModal(false)}>
                    <div style={{ ...modalStyle, maxWidth: '800px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <div style={modalHeaderLeftStyle}>
                                <div style={modalHeaderIconStyle}>
                                    <FaDollarSign size={18} />
                                </div>
                                <h3 style={modalTitleStyle}>
                                    Quotation - {selectedQuotation.vendorName}
                                </h3>
                            </div>
                            <button
                                onClick={() => setShowViewModal(false)}
                                style={modalCloseStyle}
                            >
                                <FaTimes />
                            </button>
                        </div>

                        <div style={modalBodyStyle}>
                            <div style={quotationHeaderStyle}>
                                <div style={quotationHeaderLeftStyle}>
                                    <div style={quotationCustomerStyle}>
                                        <h4>{selectedQuotation.customerName}</h4>
                                        <p><strong>Vendor:</strong> {selectedQuotation.vendorName}</p>
                                    </div>
                                </div>
                                <div style={quotationHeaderRightStyle}>
                                    <div style={quotationMetaStyle}>
                                        <div><strong>Status:</strong> {getStatusBadge(selectedQuotation.status)}</div>
                                        <div><strong>Quoted Amount:</strong> ₹{selectedQuotation.quotedAmount.toLocaleString()}</div>
                                        <div><strong>Date:</strong> {selectedQuotation.quotationDate}</div>
                                    </div>
                                </div>
                            </div>

                            {/* Items Table */}
                            <div style={quotationItemsStyle}>
                                <h4 style={itemsTitleStyle}>Menu Items</h4>
                                <table style={itemsTableStyle}>
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: 'left' }}>Item</th>
                                            <th style={{ textAlign: 'center' }}>Quantity</th>
                                            <th style={{ textAlign: 'center' }}>Price (₹)</th>
                                            <th style={{ textAlign: 'right' }}>Total (₹)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedQuotation.items && selectedQuotation.items.map((item, idx) => (
                                            <tr key={idx}>
                                                <td>{item.name}</td>
                                                <td style={{ textAlign: 'center' }}>{item.quantity}</td>
                                                <td style={{ textAlign: 'center' }}>₹{item.price}</td>
                                                <td style={{ textAlign: 'right' }}>₹{(item.quantity * item.price).toLocaleString()}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan="3" style={{ textAlign: 'right', fontWeight: 600 }}>Total:</td>
                                            <td style={{ textAlign: 'right', fontWeight: 700, color: '#e66d33' }}>
                                                ₹{selectedQuotation.quotedAmount.toLocaleString()}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                            <div style={formActionStyle}>
                                <button
                                    onClick={() => setShowViewModal(false)}
                                    style={cancelButtonStyle}
                                >
                                    Close
                                </button>
                                <button
                                    style={printLargeButtonStyle}
                                >
                                    <FaPrint size={14} />
                                    Print
                                </button>
                                <button
                                    style={pdfLargeButtonStyle}
                                >
                                    <FaFilePdf size={14} />
                                    Export PDF
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Send to Vendors Modal */}
            {showSendModal && selectedQuotation && (
                <div style={modalOverlayStyle} onClick={() => setShowSendModal(false)}>
                    <div style={{ ...modalStyle, maxWidth: '550px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <div style={modalHeaderLeftStyle}>
                                <div style={modalHeaderIconStyle}>
                                    <FaPaperPlane size={18} />
                                </div>
                                <h3 style={modalTitleStyle}>Send Quotation to Vendors</h3>
                            </div>
                            <button
                                onClick={() => setShowSendModal(false)}
                                style={modalCloseStyle}
                            >
                                <FaTimes />
                            </button>
                        </div>

                        <div style={modalBodyStyle}>
                            <div style={sendInfoStyle}>
                                <p><strong>Customer:</strong> {selectedQuotation.customerName}</p>
                                <p><strong>Vendor:</strong> {selectedQuotation.vendorName}</p>
                                <p><strong>Amount:</strong> ₹{selectedQuotation.quotedAmount?.toLocaleString()}</p>
                            </div>

                            <div style={vendorSelectAllStyle}>
                                <label style={checkboxLabelStyle}>
                                    <input
                                        type="checkbox"
                                        checked={selectAll}
                                        onChange={handleSelectAll}
                                    />
                                    <strong>Select All Vendors</strong>
                                </label>
                            </div>

                            <div style={vendorListStyle}>
                                {vendors.map(vendor => (
                                    <div key={vendor.id} style={vendorItemStyle}>
                                        <label style={checkboxLabelStyle}>
                                            <input
                                                type="checkbox"
                                                checked={selectedVendors[vendor.id] || false}
                                                onChange={() => handleVendorSelect(vendor.id)}
                                            />
                                            <div>
                                                <div style={{ fontWeight: 600 }}>{vendor.name}</div>
                                                <div style={{ fontSize: '12px', color: '#888' }}>{vendor.email}</div>
                                            </div>
                                        </label>
                                    </div>
                                ))}
                            </div>

                            <div style={formActionStyle}>
                                <button
                                    type="button"
                                    onClick={() => setShowSendModal(false)}
                                    style={cancelButtonStyle}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSendToVendors}
                                    style={sendButtonLargeStyle}
                                >
                                    <FaPaperPlane size={14} />
                                    Send to Selected Vendors
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
            `}</style>
        </div>
    );
};

// ─── Styles ──────────────────────────────────────────────────────

const containerStyle = {
  
};

const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '16px',
};

const headerLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
};

const headerIconStyle = {
    width: '44px',
    height: '44px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
};

const titleStyle = {
    fontSize: '24px',
    fontWeight: 700,
    color: '#111827',
    margin: 0,
    letterSpacing: '-0.5px',
};

const subtitleStyle = {
    fontSize: '14px',
    color: '#6B7280',
    margin: '4px 0 0 0',
};

const headerRightStyle = {
    display: 'flex',
    gap: '10px',
};

const refreshButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '10px 18px',
    background: '#fff',
    color: '#4B5563',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    fontWeight: 500,
    fontSize: '13px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

const exportAllButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 20px',
    background: '#dc3545',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

const statsContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px',
    marginBottom: '24px',
};

const statCardStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    background: '#fff',
    padding: '18px 20px',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    border: '1px solid #E5E7EB',
    transition: 'all 0.2s ease',
};

const statIconWrapperStyle = {
    width: '44px',
    height: '44px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const statNumberStyle = {
    fontSize: '22px',
    fontWeight: 700,
    color: '#111827',
    lineHeight: 1.2,
};

const statLabelStyle = {
    fontSize: '13px',
    color: '#6B7280',
    fontWeight: 500,
};

// ─── Search & Filter Styles ─────────────────────────────────────

const searchFilterContainerStyle = {
    display: 'flex',
    gap: '12px',
    marginBottom: '20px',
    flexWrap: 'wrap',
};

const searchContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: '200px',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    padding: '0 16px',
    transition: 'all 0.2s ease',
};

const searchIconStyle = {
    color: '#9CA3AF',
    marginRight: '10px',
};

const searchInputStyle = {
    flex: 1,
    padding: '11px 0',
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    background: 'transparent',
    color: '#111827',
};

const filterContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    padding: '0 14px',
};

const filterIconStyle = {
    color: '#6B7280',
    marginRight: '10px',
    fontSize: '13px',
};

const filterSelectStyle = {
    padding: '11px 8px',
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    background: 'transparent',
    cursor: 'pointer',
    color: '#111827',
};

// ─── Table Styles ──────────────────────────────────────────────

const tableCardStyle = {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    border: '1px solid #E5E7EB',
};

const tableWrapperStyle = {
     overflowX: 'auto',
    padding: '0',
    maxHeight: "50vh",
    scrollbarWidth: "thin",
};

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '1100px',
};
const thStyle = {
    padding: '12px 16px',
    fontSize: '12px',
    fontWeight: 600,
    color: '#6B7280',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    background: '#F9FAFB',
    borderBottom: '1px solid #E5E7EB',
};
const tdStyle = {
    padding: '12px 16px',
    fontSize: '13px',
    color: '#111827',
    borderBottom: '1px solid #F3F4F6',
};

const tableRowStyle = {
    transition: 'background 0.15s ease',
    cursor: 'default',
};

const emptyStateStyle = {
    padding: '60px 20px',
    textAlign: 'center',
    borderBottom: 'none',
};

const emptyStateContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
};

const loadingStyle = {
    padding: '60px 20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    color: '#6B7280',
};

// ─── Badge Styles ──────────────────────────────────────────────

const platesBadgeStyle = {
    display: 'inline-block',
    padding: '2px 10px',
    background: 'rgba(230, 126, 34, 0.1)',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 600,
    color: '#e66d33',
};

const pendingBadgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 12px',
    background: '#FEF3C7',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: 600,
    color: '#92400E',
};

const approvedBadgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 12px',
    background: '#D1FAE5',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: 600,
    color: '#065F46',
};

const rejectedBadgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 12px',
    background: '#FEE2E2',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: 600,
    color: '#991B1B',
};

const quotedBadgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 12px',
    background: '#E0E7FF',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: 600,
    color: '#3730A3',
};

const eventBadgeStyle = {
    display: 'inline-block',
    padding: '2px 10px',
    background: '#F3F4F6',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    color: '#4B5563',
};

const quotedAmountStyle = {
    fontWeight: 600,
    color: '#059669',
};

// ─── Customer Cell ──────────────────────────────────────────────

const customerCellStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
};

const avatarStyle = {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: 600,
    flexShrink: 0,
};

// ─── Vendor Tags ──────────────────────────────────────────────

const vendorsContainerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    justifyContent: 'center',
};

const vendorTagStyle = {
    padding: '2px 8px',
    background: '#F3F4F6',
    borderRadius: '4px',
    fontSize: '10px',
    color: '#4B5563',
};

const vendorTagLargeStyle = {
    display: 'inline-block',
    padding: '4px 12px',
    background: '#F3F4F6',
    borderRadius: '6px',
    fontSize: '13px',
    color: '#4B5563',
    marginRight: '6px',
};

// ─── Action Buttons ─────────────────────────────────────────────

const actionGroupStyle = {
    display: 'flex',
    gap: '6px',
    flexWrap: 'wrap',
    justifyContent: 'center',
};

const viewButtonStyle = {
    padding: '6px 10px',
    background: '#DBEAFE',
    color: '#1D4ED8',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const sendButtonStyle = {
    padding: '6px 10px',
    background: '#D1FAE5',
    color: '#065F46',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const approveButtonStyle = {
    padding: '6px 10px',
    background: '#D1FAE5',
    color: '#059669',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const rejectButtonStyle = {
    padding: '6px 10px',
    background: '#FEE2E2',
    color: '#DC2626',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const printButtonStyle = {
    padding: '6px 10px',
    background: '#F3F4F6',
    color: '#4B5563',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

const pdfButtonStyle = {
    padding: '6px 10px',
    background: '#FEE2E2',
    color: '#DC2626',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '13px',
};

// ─── Modal Styles ──────────────────────────────────────────────

const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '20px',
};

const modalStyle = {
    background: '#fff',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '700px',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
};

const modalHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid #F3F4F6',
    position: 'sticky',
    top: 0,
    background: '#fff',
    zIndex: 1,
};

const modalHeaderLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
};

const modalHeaderIconStyle = {
    width: '36px',
    height: '36px',
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
};

const modalTitleStyle = {
    margin: 0,
    fontSize: '18px',
    fontWeight: 700,
    color: '#111827',
};

const modalCloseStyle = {
    background: '#F3F4F6',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
    color: '#6B7280',
    padding: '6px 10px',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
};

const modalBodyStyle = {
    padding: '24px',
};

// ─── Quotation View Styles ─────────────────────────────────────

const quotationHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px',
    background: '#F9FAFB',
    borderRadius: '10px',
    marginBottom: '16px',
    flexWrap: 'wrap',
    gap: '12px',
};

const quotationHeaderLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
};

const quotationCustomerStyle = {
    '& h4': {
        margin: 0,
        fontSize: '16px',
        fontWeight: 700,
        color: '#111827',
    },
    '& p': {
        margin: '2px 0',
        fontSize: '14px',
        color: '#6B7280',
    },
};

const contactInfoStyle = {
    display: 'flex',
    gap: '16px',
    marginTop: '4px',
    '& span': {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        fontSize: '13px',
        color: '#6B7280',
    },
};

const quotationHeaderRightStyle = {
    display: 'flex',
    alignItems: 'center',
};

const quotationMetaStyle = {
    fontSize: '13px',
    color: '#6B7280',
    '& div': {
        marginBottom: '2px',
    },
};

const quotationEventStyle = {
    display: 'flex',
    gap: '20px',
    padding: '12px 16px',
    background: '#fff',
    borderRadius: '8px',
    border: '1px solid #F3F4F6',
    marginBottom: '16px',
    flexWrap: 'wrap',
};

const quotationEventItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '14px',
    color: '#374151',
};

const quotationItemsStyle = {
    marginBottom: '16px',
};

const itemsTitleStyle = {
    margin: '0 0 8px 0',
    fontSize: '15px',
    fontWeight: 600,
    color: '#111827',
};

const itemsTableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
};

const quotationVendorsStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 16px',
    background: '#F9FAFB',
    borderRadius: '8px',
    marginBottom: '16px',
    flexWrap: 'wrap',
};

const quotationSummaryStyle = {
    padding: '16px',
    background: '#fff',
    borderRadius: '8px',
    border: '1px solid #F3F4F6',
    marginBottom: '16px',
};

const summaryRowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 0',
    fontSize: '14px',
};

const summaryValueStyle = {
    fontWeight: 600,
    color: '#111827',
};

const quotedSummaryValueStyle = {
    fontWeight: 700,
    color: '#059669',
};

// ─── Form Action Styles ────────────────────────────────────────

const formActionStyle = {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
    marginTop: '16px',
    paddingTop: '16px',
    borderTop: '1px solid #F3F4F6',
};

const cancelButtonStyle = {
    padding: '10px 24px',
    background: '#F3F4F6',
    color: '#4B5563',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

const printLargeButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 24px',
    background: '#6B7280',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

const pdfLargeButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 24px',
    background: '#DC2626',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

// ─── Send Modal Styles ──────────────────────────────────────────

const sendInfoStyle = {
    background: '#F9FAFB',
    padding: '12px 16px',
    borderRadius: '8px',
    marginBottom: '16px',
    '& p': {
        margin: '4px 0',
        fontSize: '14px',
    },
};

const vendorSelectAllStyle = {
    padding: '12px 0',
    borderBottom: '1px solid #F3F4F6',
    marginBottom: '12px',
};

const vendorListStyle = {
    maxHeight: '250px',
    overflowY: 'auto',
    marginBottom: '16px',
};

const vendorItemStyle = {
    padding: '10px 12px',
    borderBottom: '1px solid #F3F4F6',
};

const checkboxLabelStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    cursor: 'pointer',
    fontSize: '14px',
};

const sendButtonLargeStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 24px',
    background: '#059669',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
};

// Additional styles for expandable rows
const expandButtonStyle = {
    padding: '4px 8px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#6B7280',
    fontSize: '14px',
    transition: 'all 0.2s ease',
};

const expandedContentStyle = {
    padding: '16px 0 16px 40px',
    background: '#F9FAFB',
    borderTop: '1px solid #E5E7EB',
};

const subTableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
    background: '#fff',
    borderRadius: '8px',
    overflow: 'hidden',
};

const subTableHeaderStyle = {
    background: '#F3F4F6',
};

const subThStyle = {
    padding: '10px 12px',
    fontSize: '11px',
    fontWeight: 600,
    color: '#6B7280',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: '1px solid #E5E7EB',
};

const subTableRowStyle = {
    borderBottom: '1px solid #F3F4F6',
};

const subTdStyle = {
    padding: '10px 12px',
    fontSize: '13px',
    color: '#111827',
};

const vendorNameStyle = {
    fontWeight: 600,
    color: '#4F46E5',
};

const dateFilterContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '10px',
    padding: '0 14px',
    minWidth: '160px',
};

// Custom Date Modal Styles
const customDateModalOverlay = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    padding: '20px',
};

const customDateModalStyle = {
    background: '#fff',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
};

const customDateModalHeader = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid #F3F4F6',
};

const customDateModalTitle = {
    margin: 0,
    fontSize: '18px',
    fontWeight: 700,
    color: '#111827',
};

const customDateModalClose = {
    background: 'none',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    color: '#6B7280',
    padding: '4px 8px',
};

const customDateModalBody = {
    padding: '24px',
};

const customDateModalInputGroup = {
    marginBottom: '16px',
};

const customDateModalLabel = {
    display: 'block',
    fontSize: '13px',
    fontWeight: 500,
    color: '#374151',
    marginBottom: '6px',
};

const customDateModalInput = {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    background: '#fff',
    color: '#111827',
    boxSizing: 'border-box',
};

const customDateModalFooter = {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    padding: '16px 24px',
    borderTop: '1px solid #F3F4F6',
};

const customDateModalCancel = {
    padding: '8px 20px',
    background: '#F3F4F6',
    color: '#4B5563',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
};

const customDateModalApply = {
    padding: '8px 24px',
    background: 'linear-gradient(135deg, #e66d33, #e66d33)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(230, 109, 51, 0.3)',
};

export default SalesQuotation;